import { HI_CASHBOOK_SUPERVISOR } from "../cashbook/i18n/hiSupervisor";
import { HI_CASHBOOK_OWNER } from "../cashbook/i18n/hiOwner";

/**
 * Hindi for the karkhana supervisor screens. Keys are the English text shown on screen; anything
 * missing here falls back to English. Shop-floor words (loom, saree, inch, girah) stay familiar.
 */
export const HI: Record<string, string> = {
  // Menu and pages
  Rounds: "राउंड",
  Attendance: "हाज़िरी",
  Pay: "भुगतान",
  Waiting: "मंज़ूरी बाकी",
  Approvals: "मंज़ूरी",
  Sarees: "साड़ियाँ",
  "Cash book": "नकद खाता",
  "Pay sheets": "भुगतान पत्रक",
  "Pay accounts": "भुगतान खाते",
  "All sheets": "सभी पत्रक",
  Finalise: "पक्का करें",
  "This draft was discarded. Nobody is paid from it.": "यह ड्राफ़्ट हटा दिया गया है। इससे भुगतान नहीं होगा।",
  Finalised: "पक्का हो गया",
  "Finalise to pay": "भुगतान से पहले पक्का करें",
  "Discard draft": "ड्राफ़्ट हटाएँ",
  "Discard this draft pay sheet?": "यह ड्राफ़्ट पत्रक हटाएँ?",
  "Draft discarded": "ड्राफ़्ट हटा दिया",
  "This needs a connection. Nothing was saved.": "इसके लिए इंटरनेट चाहिए। कुछ सेव नहीं हुआ।",
  "A draft made by the AI assistant. Check it and print it if you like, then Finalise to pay people from it, or Discard it.":
    "AI सहायक का बनाया ड्राफ़्ट। जाँचें, चाहें तो छापें, फिर भुगतान के लिए पक्का करें या हटा दें।",
  "A draft made by the AI assistant. Nobody is paid from it until the owner finalises it.":
    "AI सहायक का बनाया ड्राफ़्ट। मालिक के पक्का करने तक इससे भुगतान नहीं होगा।",
  Account: "खाता",

  // Common
  All: "सभी",
  Today: "आज",
  Done: "हो गया",
  Closed: "बंद",
  "To do": "बाकी",
  Error: "गड़बड़ी",
  Sent: "भेज दिया",
  Save: "सेव करें",
  "Saving…": "सेव हो रहा है…",
  Saved: "सेव हो गया",
  "Not saved": "सेव नहीं हुआ",
  Back: "वापस",
  Cancel: "रद्द करें",
  Remove: "हटाएँ",
  Undo: "वापस लें",
  Check: "जाँचें",
  Change: "बदलें",
  Set: "सेट करें",
  Refresh: "ताज़ा करें",
  "Refreshing…": "ताज़ा हो रहा है…",
  Refreshed: "ताज़ा हो गया",
  "Loading…": "लोड हो रहा है…",
  Discard: "हटा दें",
  "Send now": "अभी भेजें",
  "On phone": "फ़ोन में",
  "No connection": "नेटवर्क नहीं है",
  "No signal": "सिग्नल नहीं है",
  "Could not reach the server": "सर्वर से संपर्क नहीं हो पाया",
  "Something went wrong": "कुछ गड़बड़ हो गई",
  "Could not save": "सेव नहीं हो पाया",
  "Could not update": "बदलाव नहीं हो पाया",
  "Could not remove": "हटा नहीं पाए",
  "Could not record": "दर्ज नहीं हो पाया",
  "Could not refresh": "ताज़ा नहीं हो पाया",
  "This needs a connection. Try again in a moment.": "इसके लिए नेटवर्क चाहिए। थोड़ी देर में फिर कोशिश करें।",
  "Needs a connection": "नेटवर्क चाहिए",
  "Note (optional)": "नोट (ज़रूरी नहीं)",
  "Say why": "कारण बताएँ",
  "A short reason is kept with the change": "बदलाव के साथ छोटा-सा कारण रखा जाता है",
  "by {{name}}": "{{name}} द्वारा",
  "entered by {{name}}": "{{name}} ने दर्ज किया",
  "since {{day}}": "{{day}} से",
  "…and {{n}} more": "…और {{n}}",
  Map: "नक्शा",
  Time: "समय",
  Now: "अभी",
  Work: "काम",
  Total: "कुल",

  // Rounds
  "Could not load the looms": "लूम लोड नहीं हो पाए",
  "{{n}} saved entries sent": "फ़ोन में सेव {{n}} एंट्री भेज दी गईं",
  "Round done": "राउंड पूरा",
  "No more pending looms with a saree": "साड़ी वाला कोई लूम बाकी नहीं",
  "Added without location": "लोकेशन के बिना जोड़ा गया",
  "Couldn't get a location": "लोकेशन नहीं मिल पाई",
  "Could not add looms": "लूम नहीं जुड़ पाए",
  "Looms added": "लूम जुड़ गए",
  "{{n}} added": "{{n}} जुड़े",
  "{{n}} already there": "{{n}} पहले से थे",
  "No connection. You can keep entering work; it is sent when the signal is back.": "नेटवर्क नहीं है। काम दर्ज करते रहें; सिग्नल आने पर भेज दिया जाएगा।",
  "{{n}} entries saved on this phone, not sent yet.": "{{n}} एंट्री इस फ़ोन में सेव हैं, अभी भेजी नहीं गईं।",
  "{{day}} is 3 or more days back. Entries for it wait for the admin's approval.": "{{day}} तीन या ज़्यादा दिन पुराना है। इसकी एंट्री एडमिन की मंज़ूरी का इंतज़ार करेंगी।",
  "Add more looms": "और लूम जोड़ें",
  "Add your looms": "अपने लूम जोड़ें",
  "Type codes or ranges, e.g.": "कोड या रेंज लिखें, जैसे",
  "Codes already added are skipped.": "पहले से जुड़े कोड छोड़ दिए जाते हैं।",
  "Adding…": "जोड़ रहे हैं…",
  "Add looms": "लूम जोड़ें",
  "Tag them with where I'm standing (stand in that shed). Each loom can be re-tagged from its sheet.": "मेरी जगह की लोकेशन लगाएँ (उसी शेड में खड़े हों)। हर लूम की लोकेशन बाद में भी बदली जा सकती है।",
  "Find a loom, e.g. N05": "लूम खोजें, जैसे N05",
  alone: "अकेले",
  "No saree — tap to start one": "साड़ी नहीं — शुरू करने के लिए दबाएँ",

  // Loom sheet
  "Loom register": "लूम रजिस्टर",
  "Geotag verified": "जियोटैग जाँचा गया",
  Geotagged: "जियोटैग हुआ",
  "Not geotagged": "जियोटैग नहीं",
  "Tag again here": "यहीं दोबारा टैग करें",
  "Tag location here": "यहाँ की लोकेशन लगाएँ",
  "Add {{side}} photo": "{{side}} फ़ोटो लगाएँ",
  "Retake {{side}} photo": "{{side}} फ़ोटो दोबारा लें",
  front: "सामने की",
  back: "पीछे की",
  left: "बाईं ओर की",
  right: "दाईं ओर की",
  "Already registered on the Looms page? Link it": "लूम पेज पर पहले से दर्ज है? जोड़ें",
  "Link {{code}} to": "{{code}} को जोड़ें",
  "No other registered looms to link.": "जोड़ने के लिए कोई और दर्ज लूम नहीं।",
  "Entered {{m}} m": "दर्ज {{m}} मीटर",
  "of {{m}} m": "{{m}} मीटर में से",
  "Check length": "लंबाई जाँचें",
  "measured {{m}} m ({{in}}) vs {{e}} entered": "नापा {{m}} मीटर ({{in}}), दर्ज {{e}}",
  "matches ✓": "मेल खाता है ✓",
  "{{d}} less entered. An entry may be missing.": "{{d}} कम दर्ज है। कोई एंट्री छूट गई होगी।",
  "{{d}} more entered than woven. Check before paying.": "बुनाई से {{d}} ज़्यादा दर्ज है। भुगतान से पहले जाँचें।",
  "No approved rate for this design and work type on this day. The entry is still saved and flagged.": "इस दिन इस डिज़ाइन और काम का मंज़ूर रेट नहीं है। एंट्री फिर भी सेव होगी और चिह्नित रहेगी।",
  Weaver: "बुनकर",
  Helper: "हेल्पर",
  Saree: "साड़ी",
  Design: "डिज़ाइन",
  "Alone allowance": "अकेले बुनाई भत्ता",
  Incentive: "इंसेंटिव",
  "needs {{n}} in today": "आज {{n}} इंच चाहिए",
  "Enter the inches woven": "बुनाई के इंच लिखें",
  "Inches alone can't be more than the total": "अकेले के इंच कुल से ज़्यादा नहीं हो सकते",
  "Check the entry": "एंट्री जाँचें",
  "Check the inches": "इंच जाँचें",
  "Tap Save again to keep it.": "रखना है तो फिर से सेव दबाएँ।",
  "That makes {{after}} in on a {{full}} in saree. Check the number.": "इससे {{full}} इंच की साड़ी पर {{after}} इंच हो जाएगा। संख्या जाँचें।",
  "{{today}} in is far more than one day's weaving. Check the number.": "{{today}} इंच एक दिन की बुनाई से बहुत ज़्यादा है। संख्या जाँचें।",
  "Saved for approval": "मंज़ूरी के लिए सेव",
  "Saved on this phone": "इस फ़ोन में सेव",
  "{{code}} will be sent when there is signal": "सिग्नल आने पर {{code}} भेज दिया जाएगा",
  "No location": "लोकेशन नहीं",
  "Photo not saved": "फ़ोटो सेव नहीं हुई",
  "Could not upload the photo": "फ़ोटो अपलोड नहीं हो पाई",
  "Enter a whole number, e.g. 14500": "पूरी संख्या लिखें, जैसे 14500",
  "Saree numbers start at {{n}}": "साड़ी नंबर {{n}} से शुरू",
  "A saree number is digits only, e.g. 14500": "साड़ी नंबर में सिर्फ़ अंक हों, जैसे 14500",
  "Choose the design, weaver and helper": "डिज़ाइन, बुनकर और हेल्पर चुनें",
  "Saree started on {{code}}": "{{code}} पर साड़ी शुरू",
  "Write {{n}} on the saree's tag": "साड़ी के टैग पर {{n}} लिखें",
  "Saree {{n}} is complete on {{day}}?": "साड़ी {{n}} {{day}} को पूरी हुई?",
  "Saree {{n}} complete": "साड़ी {{n}} पूरी",
  "Choose the weaver and helper": "बुनकर और हेल्पर चुनें",
  "Choose why the loom is closed": "लूम बंद होने का कारण चुनें",
  "Enter the length": "लंबाई लिखें",
  "Remove {{what}} from {{code}}? Say why:": "{{code}} से {{what}} हटाएँ? कारण लिखें:",
  "This day is 3 or more days back. Entries wait for the admin's approval.": "यह दिन तीन या ज़्यादा दिन पुराना है। एंट्री एडमिन की मंज़ूरी का इंतज़ार करेंगी।",
  "Full length of saree {{n}}": "साड़ी {{n}} की पूरी लंबाई",
  "How much of saree {{n}} is woven?": "साड़ी {{n}} कितनी बुनी गई?",
  "This is the saree's full length (to show progress), not a measurement": "यह साड़ी की पूरी लंबाई है (प्रगति दिखाने के लिए), नाप नहीं",
  "Measure what's on the loom; HKP compares it with the inches entered for this saree.": "लूम पर जितना बुना है उसे नापें; HKP इसे इस साड़ी के दर्ज इंच से मिलाएगा।",
  "Closed since {{day}} ({{why}}). Saving work below reopens it.": "{{day}} से बंद ({{why}})। नीचे काम सेव करने पर लूम फिर चालू हो जाएगा।",
  "Reopen without work": "बिना काम के चालू करें",
  "Work type": "काम का प्रकार",
  inch: "इंच",
  girah: "गिरह",
  m: "मीटर",
  "Helper left partway": "हेल्पर बीच में चला गया",
  "How many girah alone?": "अकेले कितने गिरह?",
  "How many inches alone?": "अकेले कितने इंच?",
  "Already entered for this day": "इस दिन पहले से दर्ज",
  waiting: "मंज़ूरी बाकी",
  rejected: "नामंज़ूर",
  "No rate": "रेट नहीं",
  "Change people": "लोग बदलें",
  "Close loom": "लूम बंद करें",
  "Finish saree": "साड़ी ख़त्म करें",
  "New saree": "नई साड़ी",
  "Saree number": "साड़ी नंबर",
  "Number on the saree's tag": "साड़ी के टैग का नंबर",
  "Getting the next number…": "अगला नंबर आ रहा है…",
  "Saree numbers aren't set up yet. Ask the studio admin to set the first number.": "साड़ी नंबर अभी सेट नहीं हैं। स्टूडियो एडमिन से पहला नंबर सेट करवाएँ।",
  "next number, given when you start": "अगला नंबर, शुरू करते ही मिलेगा",
  "Use the next number instead": "अगला नंबर ही लें",
  "Saree already on the loom before HKP? Enter its number": "HKP से पहले से लूम पर साड़ी है? उसका नंबर लिखें",
  "Code or name, e.g. K_56": "कोड या नाम, जैसे K_56",
  "Code or name, e.g. J_120": "कोड या नाम, जैसे J_120",
  "Code or name, e.g. J12": "कोड या नाम, जैसे J12",
  "With helper": "हेल्पर के साथ",
  "Working alone": "अकेले काम",
  "It stays closed every day until work is entered or it is reopened.": "काम दर्ज होने या दोबारा चालू होने तक यह रोज़ बंद रहेगा।",
  "Save · next loom": "सेव · अगला लूम",
  "Start saree": "साड़ी शुरू करें",
  "Save people": "लोग सेव करें",
  "Save length": "लंबाई सेव करें",
  "Saree {{n}} is": "साड़ी {{n}}",
  "On {{day}}. Work entered for it stays and is still paid.": "{{day}} को। इसका दर्ज काम बना रहेगा और भुगतान होगा।",
  Completed: "पूरी हुई",
  Stopped: "रुकी",
  Cut: "कटी",
  "Weaver absent": "बुनकर ग़ैरहाज़िर",
  "No yarn": "धागा नहीं",
  Repair: "मरम्मत",
  Vacant: "ख़ाली",
  "Couldn't measure": "नाप नहीं पाए",
  Other: "अन्य",

  // Attendance
  "Could not load attendance": "हाज़िरी लोड नहीं हो पाई",
  "{{n}} saved punches sent": "फ़ोन में सेव {{n}} हाज़िरी भेज दी गईं",
  In: "अंदर",
  Out: "बाहर",
  "To fix": "ठीक करना है",
  Fix: "ठीक करें",
  "No connection. You can keep marking people; it is sent when the signal is back.": "नेटवर्क नहीं है। हाज़िरी लगाते रहें; सिग्नल आने पर भेज दी जाएगी।",
  "Find someone, e.g. J12": "किसी को खोजें, जैसे J12",
  "Missing an In or Out": "अंदर या बाहर छूटा है",
  "{{work}} since {{time}}": "{{time}} से {{work}}",
  "Mark arrival": "आने की हाज़िरी",
  "Usual work": "रोज़ का काम",
  "Loom work": "लूम का काम",
  "Time work": "घंटे का काम",
  "Loom work (paid by the inch)": "लूम का काम (इंच के हिसाब से भुगतान)",
  "Choose the person": "व्यक्ति चुनें",
  "Search by code or name": "कोड या नाम से खोजें",
  "Enter the time": "समय लिखें",
  "When did this happen?": "यह कब हुआ?",
  "{{code}} is sent when the signal is back": "सिग्नल आने पर {{code}} भेज दिया जाएगा",
  "Why is the {{what}} at {{time}} being removed?": "{{time}} की {{what}} हाज़िरी क्यों हटा रहे हैं?",
  "Not removed": "हटाया नहीं गया",
  "Undo needs signal. Try again in a moment.": "वापस लेने के लिए सिग्नल चाहिए। थोड़ी देर में कोशिश करें।",
  "Came in at this time? Change it if not.": "इसी समय आए? नहीं तो समय बदलें।",
  "Went out at this time? Change it if not.": "इसी समय गए? नहीं तो समय बदलें।",
  "Mark in at {{time}}": "{{time}} पर इन लगाएँ",
  "Choose a reason": "कारण चुनें",
  "Practice / training entry": "अभ्यास / ट्रेनिंग की एंट्री",
  "Wrong person": "गलत व्यक्ति",
  "Wrong time": "गलत समय",
  "Marked twice": "दो बार लगी",
  "Didn't come": "आए नहीं थे",
  "Reason": "कारण",
  "Changing a time needs signal. Try again in a moment.": "समय बदलने के लिए सिग्नल चाहिए। थोड़ी देर में कोशिश करें।",
  "Not changed": "नहीं बदला",
  "Could not change the time": "समय नहीं बदल सका",
  "New time": "नया समय",
  "Change the {{what}} time {{time}}": "{{what}} का समय {{time}} बदलें",
  "was {{time}}": "पहले {{time}}",
  "This day is 3 or more days back. Punches wait for the admin's approval.": "यह दिन तीन या ज़्यादा दिन पुराना है। हाज़िरी एडमिन की मंज़ूरी का इंतज़ार करेगी।",
  "Who came in": "कौन आया",
  "Some punches on this day wait for the admin's approval.": "इस दिन की कुछ हाज़िरी एडमिन की मंज़ूरी का इंतज़ार कर रही है।",
  "Switched to": "बदलकर",
  "Held until fixed": "ठीक होने तक रुका",
  "No time rate set": "घंटे का रेट सेट नहीं",
  "Going out for": "बाहर जाने का कारण",
  "Time out is not paid. Mark them In when they are back.": "बाहर का समय भुगतान में नहीं जुड़ता। लौटने पर अंदर लगाएँ।",
  "Now on {{work}} since {{time}}. Moving to:": "{{time}} से {{work}} पर। अब इस पर:",
  "Switch work": "काम बदलें",
  Switch: "बदलें",
  "Add Out": "बाहर जोड़ें",
  "Add In": "अंदर जोड़ें",
  "In again": "फिर अंदर",
  "Mark Out": "बाहर लगाएँ",
  "Mark In": "अंदर लगाएँ",
  "In · next person": "अंदर · अगला व्यक्ति",
  Break: "ब्रेक",
  Lunch: "खाना",
  Home: "घर",
  Errand: "किसी काम से",
  "Switched work": "काम बदला",
  "Helping on a loom": "लूम पर हेल्पर",
  "Loom repair": "लूम मरम्मत",
  "Taani work": "ताना का काम",
  Dyeing: "रंगाई",
  "Nari work": "नारी का काम",
  Safai: "सफ़ाई",
  "Office work": "ऑफ़िस का काम",
  "Other time work": "अन्य घंटे का काम",

  // Pay
  "Could not load the account": "खाता लोड नहीं हो पाया",
  "The pay account needs a connection.": "भुगतान खाते के लिए नेटवर्क चाहिए।",
  "Why is this {{what}} of {{amount}} being removed?": "{{amount}} का यह {{what}} क्यों हटा रहे हैं?",
  entry: "एंट्री",
  "Pick a person to see what they earned, what they were paid, and any advance.": "किसी व्यक्ति को चुनें — उसकी कमाई, भुगतान और एडवांस देखें।",
  "Wages due": "बाकी मज़दूरी",
  "Advance owed": "बाकी एडवांस",
  "Give advance": "एडवांस दें",
  // Opening balances (owner)
  "Opening balances": "शुरुआती बकाया",
  "Opening balance": "शुरुआती बकाया",
  "Opening balances saved": "शुरुआती बकाया सेव हो गया",
  "{{n}} accounts now start on {{day}}.": "{{n}} खाते अब {{day}} से शुरू होते हैं।",
  "Old register": "पुराना रजिस्टर",
  "From your old register, type what each person's account stood at on the morning of this date. HKP counts on from these figures. Work and money entered before this date are covered by the opening and stop adding up.":
    "पुराने रजिस्टर से लिखें कि इस तारीख की सुबह हर व्यक्ति का खाता कितना था। HKP इन्हीं आँकड़ों से आगे गिनेगा। इस तारीख से पहले का काम और पैसा शुरुआती बकाया में आ गया, वह अलग से नहीं जुड़ेगा।",
  "Balances as of the start of": "इस तारीख की सुबह का बकाया",
  "Where the figures come from": "आँकड़े कहाँ से हैं",
  "Wages owed to them": "उनकी बाकी मज़दूरी",
  "Advance they hold": "उन पर एडवांस",
  "Cut each payout": "हर भुगतान में कटौती",
  needed: "ज़रूरी",
  "Opening set for {{day}}": "{{day}} का शुरुआती बकाया लगा है",
  "HKP shows: due {{due}} · advance {{adv}}": "HKP में: बाकी {{due}} · एडवांस {{adv}}",
  "Remove opening": "शुरुआती बकाया हटाएँ",
  "Why remove {{code}}'s opening balance? The account goes back to its full history.":
    "{{code}} का शुरुआती बकाया क्यों हटा रहे हैं? खाता फिर पूरे पुराने हिसाब से चलेगा।",
  "Enter the cut each payout for {{codes}}.": "{{codes}} के लिए हर भुगतान की कटौती लिखें।",
  "{{n}} to save, as of {{day}}": "{{day}} के हिसाब से {{n}} सेव करने हैं",
  "Nothing changed yet": "अभी कुछ नहीं बदला",
  "Save opening balances": "शुरुआती बकाया सेव करें",
  "Waiting for owner to confirm in Workers": "Workers में मालिक की पुष्टि बाकी",
  "No workers yet. Add them in Workers first.": "अभी कोई कारीगर नहीं। पहले Workers में जोड़ें।",
  "Could not load the people. This needs a connection.": "लोग नहीं खुले। इसके लिए इंटरनेट चाहिए।",
  "Find by code or name, e.g. K_56": "कोड या नाम से खोजें, जैसे K_56",
  "Carry over advances and unpaid wages from the old register": "पुराने रजिस्टर से एडवांस और बाकी मज़दूरी लाएँ",
  "Opening balance on {{day}}: due {{due}} · advance {{adv}}. Work and money before this date are in it.":
    "{{day}} का शुरुआती बकाया: बाकी {{due}} · एडवांस {{adv}}। इस तारीख से पहले का काम और पैसा इसी में है।",
  "In the opening": "शुरुआती बकाया में",
  due: "बाकी",
  advance: "एडवांस",
  "Not counted yet:": "अभी गिना नहीं गया:",
  "No work recorded in these dates.": "इन तारीख़ों में कोई काम दर्ज नहीं।",
  "Money given": "दिया गया पैसा",
  "Nothing paid or advanced yet.": "अभी कोई भुगतान या एडवांस नहीं।",
  "cut {{amount}} each payout": "हर भुगतान में {{amount}} कटौती",
  Paid: "भुगतान हुआ",
  "Advance given": "एडवांस दिया",
  "Cut for advance": "एडवांस कटौती",
  Adjustment: "समायोजन",
  Cash: "नकद",
  UPI: "UPI",
  Bank: "बैंक",
  "Pay wages": "मज़दूरी दें",
  "Hand over": "हाथ में दें",
  "Advance amount": "एडवांस रकम",
  "Agreed cut at each payout": "हर भुगतान में तय कटौती",
  "Only this much is cut each time they are paid, until the advance is repaid.": "एडवांस चुकने तक हर भुगतान में सिर्फ़ इतनी कटौती होगी।",
  "Given as": "किस तरह दिया",
  "Check the amounts": "रकम जाँचें",
  "paid {{amount}}": "{{amount}} दिया",
  "cut {{amount}}": "{{amount}} कटौती",
  "advance {{amount}}": "{{amount}} एडवांस",
  "Payment not saved": "भुगतान सेव नहीं हुआ",
  "The cut of {{amount}} was recorded, but the payment wasn't: {{why}}": "{{amount}} की कटौती दर्ज हो गई, पर भुगतान नहीं हुआ: {{why}}",
  "Money needs a connection; try again.": "पैसे के लिए नेटवर्क चाहिए; फिर कोशिश करें।",
  "Pay {{amount}}": "{{amount}} दें",
  "Give {{amount}}": "{{amount}} दें",

  // Pay sheets
  "New pay sheet": "नया भुगतान पत्रक",
  "Pick the days to pay. Everyone who worked them, or is still owed wages, gets a row.": "भुगतान के दिन चुनें। जिसने इन दिनों काम किया या जिसकी मज़दूरी बाकी है, उसकी लाइन बनेगी।",
  "Make pay sheet": "भुगतान पत्रक बनाएँ",
  "Making…": "बन रहा है…",
  "Could not make the sheet": "पत्रक नहीं बन पाया",
  "Making a pay sheet needs a connection.": "भुगतान पत्रक बनाने के लिए नेटवर्क चाहिए।",
  "Earlier sheets": "पिछले पत्रक",
  "No pay sheets yet.": "अभी कोई भुगतान पत्रक नहीं।",
  "All paid": "सबका भुगतान हुआ",
  "To pay": "भुगतान बाकी",
  "Could not load the sheet": "पत्रक लोड नहीं हो पाया",
  "The pay sheet needs a connection.": "भुगतान पत्रक के लिए नेटवर्क चाहिए।",
  "Print it again before paying from paper": "काग़ज़ से भुगतान से पहले फिर से छापें",
  "cut {{amount}} for advance": "एडवांस के लिए {{amount}} कटौती",
  "Pay {{who}} {{amount}}{{cut}}? Get their signature on the sheet.": "{{who}} को {{amount}}{{cut}} दें? पत्रक पर उनके हस्ताक्षर लें।",
  "Not paid": "भुगतान नहीं हुआ",
  "Paying needs a connection. Nothing was recorded.": "भुगतान के लिए नेटवर्क चाहिए। कुछ दर्ज नहीं हुआ।",
  "Net to pay": "देय राशि",
  "Print / Save PDF": "छापें / PDF सेव करें",
  "Print the sheet, pay each person and get their signature, then tap Pay on their row. If someone's work changed after printing, Refresh and print again.":
    "पत्रक छापें, हर व्यक्ति को भुगतान करें और हस्ताक्षर लें, फिर उनकी लाइन पर 'दें' दबाएँ। छापने के बाद किसी का काम बदला हो तो ताज़ा करके फिर छापें।",
  "earlier due {{amount}}": "पहले का बकाया {{amount}}",
  "already paid {{amount}}": "पहले दिया {{amount}}",
  "advance cut {{amount}}": "एडवांस कटौती {{amount}}",
  "advance owed {{amount}}": "बाकी एडवांस {{amount}}",
  "Nothing to pay": "देने को कुछ नहीं",
  "Sheet preview": "पत्रक की झलक",

  // Cash book
  "Could not load the cash book": "नकद खाता लोड नहीं हो पाया",
  "The cash book needs a connection.": "नकद खाते के लिए नेटवर्क चाहिए।",
  "Nothing was recorded. Try again.": "कुछ दर्ज नहीं हुआ। फिर कोशिश करें।",
  "Hand cash to a supervisor to pay people. Every cash payment or advance they record comes off what they hold.":
    "लोगों को भुगतान के लिए सुपरवाइज़र को नकद दें। वे जो भी नकद भुगतान या एडवांस दर्ज करेंगे, उनके पास की रकम से घटेगा।",
  "No supervisors yet.": "अभी कोई सुपरवाइज़र नहीं।",
  "Add one": "जोड़ें",
  "Cash in hand": "हाथ में नकद",
  "Paid out more than was handed over": "मिले से ज़्यादा भुगतान हुआ",
  "Handed over · paid out · returned": "मिला · दिया · लौटाया",
  "Hand over cash": "नकद दें",
  "Give cash back": "नकद लौटाएँ",
  "Record cash returned": "लौटाया नकद दर्ज करें",
  "Cash handed over": "दिया गया नकद",
  "Cash given back": "लौटाया गया नकद",
  "Amount, e.g. 5000": "रकम, जैसे 5000",
  "Save {{amount}}": "{{amount}} सेव करें",
  Movements: "लेन-देन",
  "No cash moved yet.": "अभी कोई नकद लेन-देन नहीं।",
  "Handed over": "मिला",
  "Given back": "लौटाया",

  // Approvals
  "Late entries to approve": "मंज़ूरी के लिए देर की एंट्री",
  "Work and attendance entered for a day 3 or more days back wait here. It isn't paid until the studio admin approves it.":
    "तीन या ज़्यादा दिन पुराने दिन का काम और हाज़िरी यहाँ रुकती है। स्टूडियो एडमिन की मंज़ूरी तक भुगतान नहीं होगा।",
  "Nothing waiting.": "कुछ भी बाकी नहीं।",
  Approve: "मंज़ूर करें",
  "Approve day": "दिन मंज़ूर करें",
  Reject: "नामंज़ूर करें",
  "Missing In/Out": "अंदर/बाहर छूटा",
  "{{h}} time work": "{{h}} घंटे का काम",
  "{{h}} loom work": "{{h}} लूम का काम",

  // Sarees
  "Each saree number becomes one HKP product. Its loom work shows on the product page as production history, never with wages.":
    "हर साड़ी नंबर एक HKP प्रोडक्ट बनता है। उसका लूम का काम प्रोडक्ट पेज पर उत्पादन इतिहास में दिखता है, मज़दूरी कभी नहीं।",
  "Saree number, design or loom": "साड़ी नंबर, डिज़ाइन या लूम",
  "No sarees yet. They appear here when started on a loom.": "अभी कोई साड़ी नहीं। लूम पर शुरू होते ही यहाँ दिखेंगी।",
  "On the loom": "लूम पर",
  "Started {{day}}": "{{day}} को शुरू",
  "finished {{day}}": "{{day}} को पूरी",
  "{{m}} m entered": "{{m}} मीटर दर्ज",
  "No product yet": "अभी प्रोडक्ट नहीं",
  "Create product draft": "प्रोडक्ट ड्राफ़्ट बनाएँ",
  "Link existing product": "मौजूदा प्रोडक्ट जोड़ें",
  "Show on public page": "पब्लिक पेज पर दिखाएँ",
  "Shown on the public page": "पब्लिक पेज पर दिख रहा है",
  "Hidden from the public page": "पब्लिक पेज से छिपाया गया",
  Unlink: "अलग करें",
  "Search your products by name": "नाम से अपने प्रोडक्ट खोजें",
  "No matching products.": "कोई मिलता प्रोडक्ट नहीं।",

  // Voice notes
  "Voice note for the admin (optional)": "एडमिन के लिए आवाज़ नोट (ज़रूरी नहीं)",
  "Saving the note…": "नोट सेव हो रहा है…",
  "The voice note didn't upload. Check the signal and record again.": "आवाज़ नोट अपलोड नहीं हुआ। सिग्नल देखें और फिर रिकॉर्ड करें।",
  "This phone's browser can't record audio here.": "इस फ़ोन का ब्राउज़र यहाँ आवाज़ रिकॉर्ड नहीं कर सकता।",
  "Microphone is blocked. Allow it for this site and try again.": "माइक बंद है। इस साइट के लिए माइक चालू करें और फिर कोशिश करें।",
  "🎙 Record why it's late": "🎙 देर का कारण रिकॉर्ड करें",
  Stop: "रोकें",
  "More…": "और…",
  "Entered by {{name}} on {{when}}": "{{when}} को {{name}} ने दर्ज किया",
  "closed from {{day}}": "{{day}} से बंद",
  "Time pay": "घंटे का भुगतान",
  "Time pay so far": "अब तक घंटे का भुगतान",
  came: "आए",
  "in now": "अभी अंदर",
  "woven today": "आज बुना",
  // Standard work types (studios can rename theirs; renamed ones stay as typed)
  "Saree before dedhi": "देढ़ी से पहले साड़ी",
  "Saree after dedhi": "देढ़ी के बाद साड़ी",
  "Saree anchal": "साड़ी आँचल",
  "Saree polka": "साड़ी पोल्का",
  Patha: "पाठा",
  "Anchal patti": "आँचल पट्टी",
  Konia: "कोनिया",
  Khakha: "खाका",
  Lehenga: "लहँगा",
  "Taani banwai": "ताना बनवाई",
  "Taani jodai": "ताना जोड़ाई",

  // Job work and tagged time work (warping, dyeing)
  "Job work": "ठेके का काम",
  "Job work needs a connection.": "ठेके के काम के लिए इंटरनेट चाहिए।",
  "Could not load job work": "ठेके का काम लोड नहीं हुआ",
  "It is paid once the studio admin approves it.": "स्टूडियो एडमिन की मंज़ूरी के बाद इसका भुगतान होगा।",
  "Added to their pay.": "उनके भुगतान में जुड़ गया।",
  "Why is this being removed?": "इसे क्यों हटाया जा रहा है?",
  "Dyeing or other work paid per job, per colour or per saree. Work paid by the hour (dyeing, warping) goes in Attendance; pick the loom or saree it was for.":
    "रंगाई या दूसरा काम जिसका भुगतान प्रति काम, प्रति रंग या प्रति साड़ी होता है। घंटे के हिसाब वाला काम (रंगाई, ताना) हाज़िरी में लिखें और उसका लूम या साड़ी चुनें।",
  "{{n}} waiting for approval": "{{n}} मंज़ूरी के लिए बाकी",
  "Add job work": "ठेके का काम जोड़ें",
  Person: "व्यक्ति",
  "Code or name, e.g. D_4": "कोड या नाम, जैसे D_4",
  Date: "तारीख़",
  "How many ({{unit}})": "कितने ({{unit}})",
  "e.g. 3": "जैसे 3",
  "Agreed rate, ₹ per {{unit}}": "तय रेट, ₹ प्रति {{unit}}",
  "e.g. 150": "जैसे 150",
  "Saree numbers (optional)": "साड़ी नंबर (ज़रूरी नहीं)",
  "e.g. 18214, 18215": "जैसे 18214, 18215",
  "e.g. red and gold for the border": "जैसे बॉर्डर के लिए लाल और सुनहरा",
  "Last two weeks": "पिछले दो हफ़्ते",
  "No job work yet.": "अभी कोई ठेके का काम नहीं।",
  "Entered by {{name}}": "{{name}} ने लिखा",
  "Waiting for approval": "मंज़ूरी बाकी",
  Rejected: "नामंज़ूर",
  "Paid by": "भुगतान किस हिसाब से",
  "Per job / lot": "प्रति काम / लॉट",
  "Per colour": "प्रति रंग",
  "Per saree": "प्रति साड़ी",
  "Per kg": "प्रति किलो",
  "Per piece": "प्रति पीस",
  job: "काम",
  colour: "रंग",
  saree: "साड़ी",
  kg: "किलो",
  piece: "पीस",
  "For (optional)": "किसके लिए (ज़रूरी नहीं)",
  "Not for one loom or saree": "किसी एक लूम या साड़ी के लिए नहीं",
  "Saree on the loom": "लूम पर साड़ी",
  "Saree {{n}} on {{code}}": "{{code}} पर साड़ी {{n}}",
  "Loom (e.g. warping its taani)": "लूम (जैसे उसका ताना बनाना)",

  // Rounds: today's people
  "Weaver today": "आज के बुनकर",
  "Helper today": "आज के हेल्पर",
  "Who wove today? Code or name, e.g. K_56": "आज किसने बुना? कोड या नाम, जैसे K_56",
  "Who helped today? Code or name, e.g. J_120": "आज किसने मदद की? कोड या नाम, जैसे J_120",
  "Back to the usual weaver ({{code}})": "रोज़ के बुनकर ({{code}}) पर वापस",
  "No helper today: the weaver works alone": "आज कोई हेल्पर नहीं: बुनकर अकेले बुन रहे हैं",


  // Daily sheet
  "The sheet needs a connection.": "शीट के लिए इंटरनेट चाहिए।",
  "Waits for approval": "मंज़ूरी बाकी",
  "No connection. Try again.": "इंटरनेट नहीं है। फिर कोशिश करें।",
  "Some lines not saved": "कुछ लाइनें सेव नहीं हुईं",
  "{{ok}} saved, {{failed}} need a look (marked in red).": "{{ok}} सेव हुईं, {{failed}} देखनी हैं (लाल में)।",
  "{{ok}} lines saved.": "{{ok}} लाइनें सेव हुईं।",
  "Daily sheet": "रोज़ की शीट",
  "Save {{n}} lines": "{{n}} लाइनें सेव करें",
  "Previous day": "पिछला दिन",
  "Next day": "अगला दिन",
  "Like the DAILY WORK sheet: each loom with a saree is a line. Weaver and helper come from last time; change them if someone else worked today. Type inches down the column (or paste a column from Google Sheets), then Save.":
    "DAILY WORK शीट जैसा: साड़ी वाले हर लूम की एक लाइन। बुनकर और हेल्पर पिछली बार वाले आते हैं; आज कोई और था तो बदलें। इंच कॉलम में नीचे लिखते जाएँ (या Google Sheets से कॉलम पेस्ट करें), फिर सेव करें।",
  "does the same one loom at a time, on a phone.": "यही काम फ़ोन पर एक-एक लूम करके करता है।",
  "No loom has a saree on this day.": "इस दिन किसी लूम पर साड़ी नहीं है।",
  "Start sarees in Rounds": "राउंड में साड़ी शुरू करें",
  Loom: "लूम",
  Inches: "इंच",
  Choose: "चुनें",
  "Alone (no helper)": "अकेले (हेल्पर नहीं)",
  "+ another part": "+ दूसरा हिस्सा",
  "Already entered for {{day}}": "{{day}} के लिए पहले से लिखा",
  "No saree on": "साड़ी नहीं है",
  "Start a saree in Rounds": "राउंड में साड़ी शुरू करें",
  "Previous loom": "पिछला लूम",
  "Next loom": "अगला लूम",

  // Saree complete / design
  "Saree complete": "साड़ी पूरी",
  "Stopped / cut": "रुकी / कटी",
  "Change design": "डिज़ाइन बदलें",
  "Saree number {{s}} stays. Pick the right design:": "साड़ी नंबर {{s}} वही रहेगा। सही डिज़ाइन चुनें:",
  "Change saree {{s}} from design {{from}} to {{to}}? Pay for its entries is worked out again with {{to}}'s rates.":
    "साड़ी {{s}} का डिज़ाइन {{from}} से {{to}} करें? इसकी एंट्री का भुगतान {{to}} के रेट से फिर से निकाला जाएगा।",
  "Change saree {{s}} from design {{from}} to {{to}}?": "साड़ी {{s}} का डिज़ाइन {{from}} से {{to}} करें?",
  "Design changed to {{to}}": "डिज़ाइन बदलकर {{to}} हुआ",
  "Not full length yet": "अभी पूरी लंबाई नहीं",
  "Saree {{n}} so far:": "साड़ी {{n}} अब तक:",
  "A full saree is about": "पूरी साड़ी लगभग",
  "Don't mark it complete yet. Go and look at the loom again: an entry may be missing. If it was taken off early, use “Stopped / cut”.":
    "अभी पूरी न करें। लूम पर फिर से देखें: कोई एंट्री छूट गई होगी। अगर पहले उतार ली गई, तो “रुकी / कटी” चुनें।",
  "Measure it": "नापें",
  "I'll look again": "फिर से देखूँगा",


  // Daily sheet cards
  "Add line": "लाइन जोड़ें",
  "Save {{n}}": "{{n}} सेव करें",
  "Type each loom's inches, then Save. Tap a loom to open it.": "हर लूम के इंच लिखें, फिर सेव करें। लूम खोलने के लिए उस पर टैप करें।",
  "Start a saree": "साड़ी शुरू करें",
  "change": "बदलें",
  "Choose the weaver": "बुनकर चुनें",
  "in": "इंच",
  "Add a line": "लाइन जोड़ें",
  "Another entry on a loom (e.g. a second part today)": "किसी लूम पर एक और एंट्री (जैसे आज दूसरा हिस्सा)",
  "Start a saree on a loom": "किसी लूम पर साड़ी शुरू करें",
  "Every loom has a saree.": "हर लूम पर साड़ी है।",
  "Add new looms": "नए लूम जोड़ें",

  // History, arrivals
  "Part being woven": "कौन सा हिस्सा बुन रहे हैं",
  "same as last time": "पिछली बार जैसा",
  "Woven today": "आज बुना",
  "More for this loom": "इस लूम के लिए और",
  "Saree {{n}} history": "साड़ी {{n}} का इतिहास",
  "All sarees on {{code}}": "{{code}} पर सभी साड़ियाँ",
  "Mark arrivals": "आने की हाज़िरी",
  "Time in": "आने का समय",
  "When did they come in?": "वे कब आए?",
  "Some not marked": "कुछ की हाज़िरी नहीं लगी",
  "Marked in": "हाज़िरी लगी",
  "{{n}} people in at {{time}}": "{{n}} लोग {{time}} पर अंदर",
  "not in yet": "अभी नहीं आए",
  "on this phone": "इस फ़ोन पर",
  "Nobody by that code or name.": "इस कोड या नाम का कोई नहीं।",
  "Everyone is in.": "सब आ गए।",
  "Clear": "हटाएँ",
  "Mark {{n}} in at {{time}}": "{{n}} की हाज़िरी {{time}} पर लगाएँ",
  "now": "अभी",
  "Select all {{n}}": "सभी {{n}} चुनें",
  "Select": "चुनें",
  "Woven": "बुना गया",
  "Days on the loom": "लूम पर दिन",
  "Cost so far": "अब तक की लागत",
  "weaving": "बुनाई",
  "hours": "घंटे",
  "job work": "ठेके का काम",
  "Weavers on this saree": "इस साड़ी के बुनकर",
  "Days": "दिन",
  "Earned": "कमाई",
  "Day by day": "दिन-ब-दिन",
  "{{n}} selected": "{{n}} चुने",
  "Correct part": "सही हिस्सा",
  "Change the part to…": "हिस्सा बदलें…",
  "Entered the wrong part on some days? Tick them and change the part together.": "कुछ दिनों में गलत हिस्सा लिखा? उन्हें चुनकर एक साथ बदलें।",
  "Part": "हिस्सा",
  "No work entered on this saree yet.": "इस साड़ी पर अभी कोई काम नहीं लिखा।",
  "Earlier, from the old sheet": "पहले का, पुरानी शीट से",
  "Change {{n}} entries to {{part}}? Their pay is worked out again.": "{{n}} एंट्री को {{part}} करें? उनका भुगतान फिर से निकाला जाएगा।",
  "{{n}} entries now {{code}}": "{{n}} एंट्री अब {{code}}",
  "{{n}} entries wait for approval and aren't counted yet.": "{{n}} एंट्री मंज़ूरी के लिए बाकी हैं, अभी गिनी नहीं गईं।",
  "{{n}} entries have no approved rate.": "{{n}} एंट्री का मंज़ूर रेट नहीं है।",
  "Complete": "पूरी",
  "No saree on this loom yet.": "इस लूम पर अभी कोई साड़ी नहीं।",
  "days": "दिन",
  "Weavers": "बुनकर",
  "loom": "लूम",

  // Pay ledger, entry correction
  "Correct the entry for {{day}}": "{{day}} की एंट्री सुधारें",
  "Entry corrected; pay worked out again.": "एंट्री सुधर गई; भुगतान फिर से निकाला गया।",
  "Edit": "सुधारें",
  "Note photo": "पर्ची की फ़ोटो",
  "Photo of the handwritten note this came from": "जिस हाथ से लिखी पर्ची से यह आया, उसकी फ़ोटो",
  "Wages due, everyone": "सबकी बकाया मज़दूरी",
  "Advance owed, everyone": "सबका बाकी एडवांस",
  "Ledger as of {{day}}": "{{day}} तक का खाता",
  "No work or money recorded yet.": "अभी कोई काम या पैसा दर्ज नहीं।",
  "Last worked": "आख़िरी काम",
  "{{n}} to check": "{{n}} जाँचने हैं",

  // Supervisor sign-in
  "Karkhana supervisor": "कारख़ाना सुपरवाइज़र",
  "Mobile number": "मोबाइल नंबर",
  "Password": "पासवर्ड",
  "Hide": "छिपाएँ",
  "Show": "दिखाएँ",
  "Signing in…": "लॉगिन हो रहा है…",
  "Sign in": "लॉगिन करें",
  "Enter your mobile number and password": "अपना मोबाइल नंबर और पासवर्ड डालें",
  "Mobile number or password is wrong": "मोबाइल नंबर या पासवर्ड गलत है",
  "Forgot the password? Ask your studio for a new one.": "पासवर्ड भूल गए? स्टूडियो से नया पासवर्ड लें।",
  "PIN (6 digits)": "पिन (6 अंक)",
  "Enter your mobile number and 6-digit PIN": "अपना मोबाइल नंबर और 6 अंकों का पिन डालें",
  "Mobile number or PIN is wrong": "मोबाइल नंबर या पिन गलत है",
  "Signing in is busy right now. Try again in a moment.": "अभी लॉगिन व्यस्त है। थोड़ी देर में फिर कोशिश करें।",
  "Karkhana is off for your studio. Ask the studio admin.": "आपके स्टूडियो के लिए कारख़ाना बंद है। स्टूडियो एडमिन से पूछें।",
  "Could not sign in. Try again, or ask the studio admin.": "लॉगिन नहीं हो पाया। फिर कोशिश करें, या स्टूडियो एडमिन से पूछें।",
  "Signed in again": "फिर से लॉगिन हो गया",
  "Refresh the page to see your work.": "अपना काम देखने के लिए पेज रीफ़्रेश करें।",
  "Could not open Karkhana. Check the internet, or ask the studio admin if it keeps happening.": "कारख़ाना नहीं खुल पाया। इंटरनेट देखें, या बार-बार हो तो स्टूडियो एडमिन से पूछें।",
  "Try again": "फिर कोशिश करें",
  "Too many wrong PINs. Try again later, or ask your studio admin for a new PIN.": "कई बार गलत पिन डाला गया। थोड़ी देर बाद कोशिश करें, या स्टूडियो एडमिन से नया पिन लें।",
  "Your access has been turned off. Ask the studio admin.": "आपकी पहुँच बंद कर दी गई है। स्टूडियो एडमिन से पूछें।",
  "Forgot the PIN? Ask your studio for a new one.": "पिन भूल गए? स्टूडियो से नया पिन लें।",
  "Sign in with password instead": "पासवर्ड से लॉगिन करें",
  "Sign in with PIN": "पिन से लॉगिन करें",
  "Opening…": "खुल रहा है…",
  "Could not reach HKP. Check the internet and try again.": "HKP से जुड़ नहीं पाए। इंटरनेट देखकर फिर कोशिश करें।",
  "You stay signed in on this phone until you log out.": "लॉग आउट करने तक आप इस फ़ोन पर लॉगिन रहेंगे।",
  "Install the Karkhana app": "कारख़ाना ऐप इंस्टॉल करें",
  "Put Karkhana on your home screen": "कारख़ाना को होम स्क्रीन पर रखें",
  "In Safari tap Share, then “Add to Home Screen”.": "Safari में शेयर दबाएँ, फिर “Add to Home Screen” चुनें।",
  "In Chrome tap ⋮, then “Add to Home screen”.": "Chrome में ⋮ दबाएँ, फिर “Add to Home screen” चुनें।",

  // Pay hand-over and take-back
  "Cut for the advance (owes {{amount}})": "एडवांस की कटौती ({{amount}} बाकी)",
  "To pay now": "अभी देना है",
  "Actually handed over": "असल में दिया",
  "Paid in full.": "पूरा भुगतान हुआ।",
  "{{amount}} more than due — it is given as an advance.": "बकाया से {{amount}} ज़्यादा — यह एडवांस में जाएगा।",
  "{{amount}} less than due — it stays due for next time.": "बकाया से {{amount}} कम — यह अगली बार के लिए बाकी रहेगा।",
  "Cut from each later payout (optional)": "आगे हर भुगतान में कटौती (ज़रूरी नहीं)",
  "Paid {{amount}}": "{{amount}} दिए",
  "Paid {{amount}} by {{name}}": "{{name}} ने {{amount}} दिए",
  "{{amount}} as advance": "{{amount}} एडवांस में",
  "Take back {{what}} of {{amount}}?": "{{amount}} का {{what}} वापस लें?",
  "Say why. It is taken back now and the reason is kept.": "कारण बताएँ। यह अभी वापस होगा और कारण दर्ज रहेगा।",
  "Say why — record it or write it. The owner or a manager approves it; until then the money still counts.": "कारण बताएँ — बोलकर रिकॉर्ड करें या लिखें। मालिक या मैनेजर मंज़ूर करेंगे; तब तक पैसा गिना जाता रहेगा।",
  "Or write the reason": "या कारण लिखें",
  "e.g. paid to the wrong person": "जैसे गलत व्यक्ति को दिया",
  "Take back": "वापस लें",
  "Send for approval": "मंज़ूरी के लिए भेजें",
  "Sent for approval": "मंज़ूरी के लिए भेजा",
  "The owner or a manager will approve it. Until then it still counts.": "मालिक या मैनेजर मंज़ूर करेंगे। तब तक यह गिना जाता रहेगा।",
  "Taken back": "वापस हुआ",
  "The account is updated.": "खाता अपडेट हो गया।",
  "Take-back waiting for approval": "वापसी मंज़ूरी के लिए बाकी",
  "Take-back turned down": "वापसी नामंज़ूर",
  "Money to take back": "वापस लेने का पैसा",
  "Asked by {{name}}": "{{name}} ने माँगा",
  "recorded by {{name}}": "{{name}} ने दर्ज किया",
  "Approve take-back": "वापसी मंज़ूर करें",
  "Keep it": "रहने दें",
  "Waiting for the owner or a manager.": "मालिक या मैनेजर की मंज़ूरी बाकी।",
  "Why keep it?": "क्यों रहने दें?",

  // Workers saved as HKP users
  "HKP post": "HKP पद",
  "Karkhana only": "सिर्फ़ कारख़ाना",
  "Karkhana only (no user)": "सिर्फ़ कारख़ाना (यूज़र नहीं)",
  "Workers of a category with an HKP post also show in Users with that post. They can't sign in.":
    "जिस श्रेणी का HKP पद है, उसके कारीगर उसी पद के साथ यूज़र्स में भी दिखते हैं। वे लॉग इन नहीं कर सकते।",
  "Each worker is added to Users as {{post}}, without a login.": "हर कारीगर {{post}} के रूप में यूज़र्स में जुड़ेगा, बिना लॉग इन के।",
  "Workers stay in Karkhana only.": "कारीगर सिर्फ़ कारख़ाने में रहेंगे।",
  "In Users": "यूज़र्स में",
  "Added by": "जोड़ने वाले:",
  "Waiting for owner to confirm": "मालिक की पुष्टि बाकी",
  "Confirm": "पुष्टि करें",
  "Confirm {{name}}?": "{{name}} की पुष्टि करें?",
  "{{who}} added {{name}} from the floor. Once you confirm, their pay can be entered.": "{{who}} ने {{name}} को फ़्लोर से जोड़ा। पुष्टि के बाद उनका भुगतान लिखा जा सकेगा।",
  "A supervisor added {{name}} from the floor. Once you confirm, their pay can be entered.": "एक सुपरवाइज़र ने {{name}} को फ़्लोर से जोड़ा। पुष्टि के बाद उनका भुगतान लिखा जा सकेगा।",
  "Confirmed": "पुष्टि हो गई",
  "{{name}} can now be paid.": "{{name}} का भुगतान अब लिखा जा सकता है।",
  "Not confirmed": "पुष्टि नहीं हुई",
  "{{count}} waiting for you to confirm": "{{count}} आपकी पुष्टि के लिए बाकी",
  "Workers a supervisor adds get paid only after you confirm them.": "सुपरवाइज़र के जोड़े वर्कर्स का भुगतान आपकी पुष्टि के बाद ही होता है।",
  "Show only waiting": "सिर्फ़ बाकी वाले दिखाएँ",
  "Show all workers": "सभी कारीगर दिखाएँ",
  "Nobody is waiting": "कोई बाकी नहीं",
  "Confirming…": "पुष्टि हो रही है…",
  "Waiting for owner": "मालिक की पुष्टि बाकी",
  "Confirm in Workers": "कारीगर पेज में पुष्टि करें",
  "Pay and advances wait until the owner confirms {{name}} in Workers.": "मालिक के कारीगर पेज में {{name}} की पुष्टि करने तक भुगतान और एडवांस रुके हैं।",
  "Sync to Users": "यूज़र्स में जोड़ें",
  "Syncing…": "जोड़ रहे हैं…",
  "Add workers to Users?": "कारीगरों को यूज़र्स में जोड़ें?",
  "Every worker whose category has an HKP post and who is not in Users yet is added, or linked to the studio user with the same phone. They can't sign in.":
    "जिस कारीगर की श्रेणी का HKP पद है और जो अभी यूज़र्स में नहीं है, उसे जोड़ा जाएगा, या उसी फ़ोन वाले स्टूडियो यूज़र से जोड़ा जाएगा। वे लॉग इन नहीं कर सकते।",
  "Added {{created}}, linked {{linked}}, not added {{skipped}}.": "{{created}} जोड़े, {{linked}} जुड़े, {{skipped}} नहीं जुड़े।",
  "Link an existing HKP user (optional)": "पहले से बने HKP यूज़र से जोड़ें (ज़रूरी नहीं)",
  "None — HKP adds one from the category": "कोई नहीं — HKP श्रेणी से खुद जोड़ेगा",

  // HKP ID, Studio ID and a worker's bank details
  "HKP ID": "HKP आईडी",
  "Studio ID": "स्टूडियो आईडी",
  "(same as the worker code)": "(कारीगर कोड जैसा ही)",
  "Bank & Aadhaar": "बैंक और आधार",
  "Only the studio admin sees these. Only the last 4 Aadhaar digits are kept.":
    "इन्हें सिर्फ़ स्टूडियो एडमिन देख सकते हैं। आधार के सिर्फ़ आख़िरी 4 अंक रखे जाते हैं।",
  "Account holder name": "खाताधारक का नाम",
  "Bank name": "बैंक का नाम",
  "Account number": "खाता नंबर",
  "UPI ID (optional)": "UPI आईडी (ज़रूरी नहीं)",
  "Aadhaar number": "आधार नंबर",
  "Type all 12 digits; HKP keeps only the last 4.": "पूरे 12 अंक लिखें; HKP सिर्फ़ आख़िरी 4 रखता है।",
  "Enter all 12 Aadhaar digits": "आधार के पूरे 12 अंक लिखें",
  "Check the IFSC: 11 characters like SBIN0001234": "IFSC जाँचें: 11 अक्षर, जैसे SBIN0001234",
  "Save bank details": "बैंक विवरण सेव करें",
  "Bank and Aadhaar details saved": "बैंक और आधार विवरण सेव हो गया",
  "Could not save bank details": "बैंक विवरण सेव नहीं हुआ",
  "Could not load bank details": "बैंक विवरण नहीं खुला",
  "Loading bank details…": "बैंक विवरण खुल रहा है…",
  "Aadhaar front": "आधार आगे",
  "Aadhaar back": "आधार पीछे",
  "Passbook or cheque": "पासबुक या चेक",
  "No photo": "फ़ोटो नहीं",
  "Add photo": "फ़ोटो जोड़ें",
  Replace: "बदलें",
  "Uploading…": "अपलोड हो रहा है…",
  "Remove {{what}}?": "{{what}} हटाएँ?",
  "Choose a JPEG or PNG photo": "JPEG या PNG फ़ोटो चुनें",
  "The photo didn't upload. Try again": "फ़ोटो अपलोड नहीं हुई। फिर से कोशिश करें",
  "Could not remove the photo": "फ़ोटो नहीं हटी",
  "Label attached": "लेबल लग गया",
  "Saree {{n}} now has label {{s}}": "साड़ी {{n}} पर अब लेबल {{s}} है",
  "HKP label on this saree": "इस साड़ी पर HKP लेबल",
  "Label": "लेबल",
  "Attach HKP label": "HKP लेबल लगाएँ",
  "Scan the HKP label pasted on the loom for saree {{n}}, or type the code printed under it.": "साड़ी {{n}} के लिए लूम पर चिपका HKP लेबल स्कैन करें, या उसके नीचे छपा कोड लिखें।",
  "Label code": "लेबल कोड",
  "Attach": "लगाएँ",
  "Scan": "स्कैन",
  "Paste an HKP label on the loom and scan it from More for this loom": "लूम पर HKP लेबल चिपकाएँ और \"इस लूम के लिए और\" में स्कैन करें",
  "HKP label": "HKP लेबल",

  // Day one: home board, adding people where they are needed, rates after the work, imports
  "1. Add your looms. 2. Tap a loom to start its saree. Weavers and helpers are added right there.": "1. अपने लूम जोड़ें। 2. लूम दबाकर उसकी साड़ी शुरू करें। बुनकर और हेल्पर वहीं जुड़ जाते हैं।",
  "10 digits": "10 अंक",
  "2–3 days": "2–3 दिन",
  "4+ days": "4+ दिन",
  "A different saree was on it: start that one": "उस पर दूसरी साड़ी थी: वह शुरू करें",
  "A mobile number has 10 digits": "मोबाइल नंबर 10 अंकों का होता है",
  "Add": "जोड़ें",
  "Add & mark in": "जोड़ें और अंदर लगाएँ",
  "Add & use": "जोड़ें और चुनें",
  "Add many people": "कई लोग एक साथ जोड़ें",
  "Add {{n}} people": "{{n}} लोग जोड़ें",
  "Add {{n}} people · {{r}} to To check": "{{n}} लोग जोड़ें · {{r}} जाँच में",
  "Add “{{name}}”": "“{{name}}” जोड़ें",
  "Added": "जुड़ गया",
  "Added {{n}} people": "{{n}} लोग जुड़ गए",
  "Added, but worth a look": "जुड़ गए, पर एक बार देख लें",
  "After logging out, this supervisor login opens again.": "लॉग आउट के बाद यही सुपरवाइज़र लॉगिन खुलेगा।",
  "Alone / NR are helper options, not workers.": "अकेले / NR हेल्पर के विकल्प हैं, लोग नहीं।",
  "Already added": "पहले से जुड़ा है",
  "Applies from": "कब से लागू",
  "Both codes were kept. Worth checking later.": "दोनों कोड रखे गए। बाद में देख लें।",
  "Cash given to supervisors": "सुपरवाइज़र को दिया नकद",
  "Cash given to you and paid out": "आपको मिला और दिया गया नकद",
  "Change what a column is, and the file is read again.": "कॉलम बदलें, फ़ाइल फिर से पढ़ी जाएगी।",
  "Check before adding": "जोड़ने से पहले देखें",
  "Check {{n}} lines": "{{n}} लाइनें जाँचें",
  "Check {{n}} people": "{{n}} लोग जाँचें",
  "Checking the file…": "फ़ाइल जाँच रहे हैं…",
  "Checking…": "जाँच रहे हैं…",
  "Choose a CSV or Excel file": "CSV या Excel फ़ाइल चुनें",
  "Choose a category, or mark as not a worker (e.g. a vendor).": "काम चुनें, या लिखें कि यह कारीगर नहीं है (जैसे दुकानदार)।",
  "Choose another file": "दूसरी फ़ाइल चुनें",
  "Choose file": "फ़ाइल चुनें",
  "Choose the design": "डिज़ाइन चुनें",
  "Choose the helper, or Weaver alone": "हेल्पर चुनें, या बुनकर अकेले",
  "Code already in HKP": "यह कोड HKP में पहले से है",
  "Code given by HKP": "कोड HKP देगा",
  "Code made uppercase": "कोड बड़े अक्षरों में किया",
  "Code repeated in file": "फ़ाइल में कोड दोबारा",
  "Codes, phone, KYC": "कोड, फ़ोन, KYC",
  "Column {{n}}": "कॉलम {{n}}",
  "Costing": "लागत",
  "Costing lines": "लागत की लाइनें",
  "Could not upload the file": "फ़ाइल अपलोड नहीं हुई",
  "Daily work": "रोज़ का काम",
  "Day or hour rate wasn't a number like 400 or 52.50.": "दिन या घंटे का रेट 400 या 52.50 जैसा नंबर नहीं था।",
  "Day rate": "दिन का रेट",
  "Day rate for {{who}}": "{{who}} का दिन का रेट",
  "Day rate not saved": "दिन का रेट सेव नहीं हुआ",
  "Design numbers": "डिज़ाइन नंबर",
  "Designs": "डिज़ाइन",
  "Designs & rates": "डिज़ाइन और रेट",
  "Details: progress, cost and people": "पूरा हाल: प्रगति, लागत और लोग",
  "Download template": "टेम्पलेट डाउनलोड करें",
  "Dyer": "रंगरेज़",
  "Earlier day…": "पहले का दिन…",
  "Earlier imports": "पहले के इम्पोर्ट",
  "Empty row": "खाली पंक्ति",
  "English and Hindi headings, a Work dropdown with your work types, an example row.": "अंग्रेज़ी और हिंदी हेडिंग, आपके काम की सूची, एक उदाहरण पंक्ति।",
  "Enter a code, or skip the row.": "कोड लिखें, या पंक्ति छोड़ दें।",
  "Enter the name": "नाम लिखें",
  "Every saree and its history": "हर साड़ी और उसका इतिहास",
  "Everyone has a photo": "सबकी फ़ोटो लग गई",
  "Everyone out · home": "सब बाहर · घर",
  "Excel download": "Excel डाउनलोड",
  "Excel or CSV, any columns. HKP finds Name, Mobile, Work and Village (Naam, Kaam, Gaon work too). Codes are optional.": "Excel या CSV, कोई भी कॉलम। HKP नाम, मोबाइल, काम और गाँव ढूँढ लेता है (Naam, Kaam, Gaon भी चलेगा)। कोड ज़रूरी नहीं।",
  "Fill rate": "रेट भरें",
  "Fill rates": "रेट भरें",
  "Find out who this is. Keep it here with a note until then.": "पता करें यह कौन है। तब तक नोट के साथ यहीं रखें।",
  "Find someone": "किसी को ढूँढें",
  "From WhatsApp or notes, one person per line, e.g. “Ganesh weaver 98390 12345”.": "WhatsApp या नोट्स से, हर लाइन में एक व्यक्ति, जैसे “Ganesh weaver 98390 12345”।",
  "From your Excel or a list": "अपनी Excel या सूची से",
  "From {{day}}. Earlier days keep the people they had.": "{{day}} से। पहले के दिनों में वही लोग रहेंगे।",
  "Guide": "मदद",
  "HKP didn't recognise the word in Work. Pick their work, or add that work type.": "HKP काम का शब्द नहीं पहचान पाया। उनका काम चुनें, या वह काम जोड़ें।",
  "HKP gives the code. Bank, KYC and pay can be added later in Workers.": "कोड HKP देगा। बैंक, KYC और मज़दूरी बाद में कारीगर पेज में जोड़ सकते हैं।",
  "HKP gives the code. The office can add bank, KYC and pay later.": "कोड HKP देगा। बैंक, KYC और मज़दूरी ऑफिस बाद में जोड़ेगा।",
  "HKP gives the code. The owner confirms them before pay or job work; the office adds bank and KYC later.":
    "कोड HKP देगा। भुगतान या जॉब वर्क से पहले मालिक पुष्टि करेंगे; बैंक और KYC ऑफिस बाद में जोड़ेगा।",
  "Added {{code}}": "{{code}} जुड़ गया",
  "The owner must confirm {{name}} before pay or job work.": "भुगतान या जॉब वर्क से पहले मालिक को {{name}} की पुष्टि करनी होगी।",
  "Hide details": "पूरा हाल छिपाएँ",
  "Hour rate": "घंटे का रेट",
  "Hourly pay, overtime and per-activity rates are in Time rates.": "घंटे की मज़दूरी, ओवरटाइम और काम के हिसाब के रेट टाइम रेट में हैं।",
  "Hours": "घंटे",
  "How it works": "कैसे चलता है",
  "How the list was read.": "सूची ऐसे पढ़ी गई।",
  "Import designs & rates": "डिज़ाइन और रेट इम्पोर्ट",
  "Import done": "इम्पोर्ट हो गया",
  "Imported": "इम्पोर्ट हुआ",
  "Imports & help": "इम्पोर्ट और मदद",
  "Karkhana": "कारख़ाना",
  "Late entries": "देर की एंट्री",
  "Later": "बाद में",
  "Left out": "छोड़े गए",
  "Lines and material prices": "लाइनें और माल के दाम",
  "Link it if it is the same person, or add them as someone new.": "वही व्यक्ति हो तो जोड़ें, नहीं तो नए व्यक्ति की तरह जोड़ें।",
  "Link it if it is the same person. Otherwise create them with a new code.": "वही व्यक्ति हो तो जोड़ें। नहीं तो नए कोड से बनाएँ।",
  "Log out": "लॉग आउट",
  "Loom not working? Mark it closed": "लूम नहीं चल रहा? बंद लगाएँ",
  "Loom numbers": "लूम नंबर",
  "Loom register (location, photo)": "लूम रजिस्टर (लोकेशन, फ़ोटो)",
  "Looms": "लूम",
  "Mark in now · {{time}}": "अभी अंदर लगाएँ · {{time}}",
  "Mark {{name}} in from the list": "{{name}} को सूची से अंदर लगाएँ",
  "Mark {{n}} people out at {{time}} (home)?": "{{n}} लोगों को {{time}} पर बाहर (घर) लगाएँ?",
  "Mobile": "मोबाइल",
  "More": "और",
  "Name": "नाम",
  "Name already in HKP": "यह नाम HKP में पहले से है",
  "New helper": "नया हेल्पर",
  "New people get their photo when they are added.": "नए लोगों की फ़ोटो जोड़ते समय लगती है।",
  "New person": "नया व्यक्ति",
  "New weaver": "नया बुनकर",
  "Next": "आगे",
  "No Work column and nothing in the name says what they do. Pick their work.": "काम का कॉलम नहीं और नाम से काम पता नहीं चलता। उनका काम चुनें।",
  "No code in the file; the next code of their work is given.": "फ़ाइल में कोड नहीं; उनके काम का अगला कोड दिया जाएगा।",
  "No code number": "कोड नंबर नहीं",
  "No looms yet.": "अभी कोई लूम नहीं।",
  "No looms yet. Add your loom numbers first.": "अभी कोई लूम नहीं। पहले अपने लूम नंबर जोड़ें।",
  "No name": "नाम नहीं",
  "No one called “{{name}}” yet": "“{{name}}” नाम का कोई नहीं",
  "No one to photograph": "किसी की फ़ोटो बाकी नहीं",
  "No prefix": "उपसर्ग नहीं",
  "No saree": "साड़ी नहीं",
  "No work or attendance between {{from}} and {{to}}. Check the dates.": "{{from}} से {{to}} के बीच कोई काम या हाज़िरी नहीं। तारीख़ें देखें।",
  "No, the loom was closed that day": "नहीं, उस दिन लूम बंद था",
  "Nobody is marked in for {{day}} yet. Tap Mark arrivals as people come in, or + New person.": "{{day}} के लिए अभी कोई अंदर नहीं। लोग आएँ तो आने की हाज़िरी दबाएँ, या + नया व्यक्ति।",
  "Nobody to pay on these dates": "इन तारीख़ों में किसी का भुगतान नहीं",
  "Not a 10-digit mobile number; add it on the worker later.": "10 अंकों का मोबाइल नहीं; बाद में कारीगर पर जोड़ें।",
  "Not a person": "व्यक्ति नहीं",
  "Not confirmed · open": "पक्का नहीं · खोलें",
  "Not counted yet": "अभी गिना नहीं गया",
  "Not marked in": "अंदर नहीं लगा",
  "Notes": "नोट",
  "Nothing to import.": "इम्पोर्ट करने को कुछ नहीं।",
  "Nothing waiting": "कुछ बाकी नहीं",
  "Old DAILY WORK sheet": "पुरानी DAILY WORK शीट",
  "On the loom since": "लूम पर कब से",
  "One file for many designs": "कई डिज़ाइन एक फ़ाइल में",
  "One photo per person": "हर व्यक्ति की एक फ़ोटो",
  "Optional · camera opens": "ज़रूरी नहीं · कैमरा खुलेगा",
  "Other parts and the incentive can be added later in Rate cards. Only the owner approves rates.": "बाकी हिस्से और इनाम बाद में रेट कार्ड में जोड़ें। रेट सिर्फ़ मालिक मंज़ूर करते हैं।",
  "Owner only": "सिर्फ़ मालिक",
  "Paste a list": "सूची चिपकाएँ",
  "Paste names": "नाम चिपकाएँ",
  "Pasted list": "चिपकाई सूची",
  "Pay per day": "दिन की मज़दूरी",
  "Pay type": "भुगतान का तरीका",
  "Pay type not used": "भुगतान का तरीका नहीं लिया",
  "People": "लोग",
  "Per hour or day": "घंटे या दिन के हिसाब",
  "Per-inch rates": "इंच के रेट",
  "Phone logins": "फ़ोन लॉगिन",
  "Phone not used": "फ़ोन नहीं लिया",
  "Photo taken ✓": "फ़ोटो ली गई ✓",
  "Photos can't come from Excel. After the import, take them in one quick round: More → Take photos.": "फ़ोटो Excel से नहीं आती। इम्पोर्ट के बाद एक चक्कर में ले लें: और → फ़ोटो लें।",
  "Pick a category. The sheet number is kept, e.g. _395 becomes K_395.": "काम चुनें। शीट का नंबर रहेगा, जैसे _395 से K_395।",
  "Print this week's sheet": "इस हफ़्ते का पत्रक छापें",
  "Rate cards": "रेट कार्ड",
  "Rate for {{design}}": "{{design}} का रेट",
  "Rate not saved": "रेट सेव नहीं हुआ",
  "Rate not used": "रेट नहीं लिया",
  "Rate saved": "रेट सेव हो गया",
  "Read as": "किस तरह पढ़ें",
  "Remember this phone": "इस फ़ोन पर याद रखें",
  "Removed": "हटा दिया",
  "Reports": "रिपोर्ट",
  "Review": "देखें",
  "S_1 body, S_3 anchal…": "S_1 बॉडी, S_3 आँचल…",
  "Same code and name are already in HKP.": "यही कोड और नाम HKP में पहले से हैं।",
  "Same name twice in the file": "फ़ाइल में एक नाम दो बार",
  "Same name, other code": "एक नाम, दूसरा कोड",
  "Same number, other prefix": "एक नंबर, दूसरा उपसर्ग",
  "Saree numbers and history": "साड़ी नंबर और इतिहास",
  "Saree parts": "साड़ी के हिस्से",
  "Saree started on loom {{code}}": "लूम {{code}} पर साड़ी शुरू हुई",
  "Saree {{n}} counts from {{day}}": "साड़ी {{n}} अब {{day}} से गिनी जाएगी",
  "Saree {{n}} is on this loom from {{day}}.": "साड़ी {{n}} इस लूम पर {{day}} से दर्ज है।",
  "Sarees & money": "साड़ियाँ और पैसा",
  "Save & approve": "सेव और मंज़ूर करें",
  "See all workers": "सभी कारीगर देखें",
  "Send {{r}} to To check": "{{r}} जाँच में भेजें",
  "Set it later in Pay": "बाद में भुगतान में भरें",
  "Set ₹/day": "₹/दिन भरें",
  "Sheet": "शीट",
  "Skip": "छोड़ें",
  "So far {{in}} in · {{gg}}": "अब तक {{in}} इंच · {{gg}}",
  "Start in 2 steps": "2 कदम में शुरू करें",
  "Supervisor": "सुपरवाइज़र",
  "Supervisors": "सुपरवाइज़र",
  "Take photo": "फ़ोटो लें",
  "Take photos": "फ़ोटो लें",
  "Take their photos": "उनकी फ़ोटो लें",
  "Tap a loom": "लूम दबाएँ",
  "Tap to open the camera": "कैमरा खोलने के लिए दबाएँ",
  "Tap to take it again": "दोबारा लेने के लिए दबाएँ",
  "The first row was used. Is this a different person with the same name?": "पहली पंक्ति ली गई। क्या यह उसी नाम का दूसरा व्यक्ति है?",
  "The first row with this code was used. Decide what this one is.": "इस कोड की पहली पंक्ति ली गई। यह क्या है, तय करें।",
  "These wait in To check after you add the rest. Nothing is guessed.": "बाकी जोड़ने के बाद ये जाँच में रहेंगे। कुछ अंदाज़े से नहीं होगा।",
  "Three ways, simplest first. Nothing is added until you check the preview. People already in HKP are never changed.": "तीन तरीके, सबसे आसान पहले। देखे बिना कुछ नहीं जुड़ेगा। HKP में पहले से जुड़े लोग नहीं बदलेंगे।",
  "Time rates": "टाइम रेट",
  "To check": "जाँच में",
  "Treated as different people, told apart by code.": "अलग लोग माने गए, कोड से पहचान।",
  "Unknown prefix": "अनजान उपसर्ग",
  "Upload the list you already have": "जो सूची आपके पास है, वही अपलोड करें",
  "Use HKP's Excel template": "HKP का Excel टेम्पलेट",
  "Use PIECE, TIME or BOTH. The category's default was used.": "PIECE, TIME या BOTH लिखें। काम का पहले वाला तरीका लिया गया।",
  "Village / address": "गाँव / पता",
  "Waiting for you": "आपके लिए बाकी",
  "Warping": "ताना",
  "Was it on the loom on {{day}} too?": "क्या {{day}} को भी यही साड़ी लूम पर थी?",
  "Weaver alone": "बुनकर अकेले",
  "Weaver's rate": "बुनकर का रेट",
  "Weaver, helper, dyer…": "बुनकर, हेल्पर, रंगरेज़…",
  "Weekly, print and sign": "हफ़्ते का, छापें और साइन कराएँ",
  "Whose account? Code or name, e.g. K_56": "किसका खाता? कोड या नाम, जैसे K_56",
  "Why is {{code}} closed?": "{{code}} बंद क्यों है?",
  "With you: {{amount}}": "आपके पास: {{amount}}",
  "Work is saved. It is paid once the rate is filled.": "काम सेव है। रेट भरते ही भुगतान में जुड़ेगा।",
  "Work is saved. The owner has been told.": "काम सेव है। मालिक को बताया गया।",
  "Work is saved; it is paid once the rate is filled.": "काम सेव है; रेट भरते ही भुगतान में जुड़ेगा।",
  "Work not known": "काम पता नहीं",
  "Work taken from the name": "काम नाम से लिया",
  "Work types & codes": "काम और कोड",
  "Work word not known": "काम का शब्द अनजान",
  "Worker code": "कारीगर कोड",
  "Workers": "कारीगर",
  "Works as": "काम",
  "Yes, count it from {{day}}": "हाँ, {{day}} से मानें",
  "Your columns": "आपके कॉलम",
  "added": "जुड़े",
  "day rate": "दिन का रेट",
  "design": "डिज़ाइन",
  "e.g. 1-12 or N01-N44": "जैसे 1-12 या N01-N44",
  "e.g. k_380 became K_380.": "जैसे k_380 से K_380।",
  "e.g. “Raju Karigar” was added as a weaver.": "जैसे “Raju Karigar” बुनकर के रूप में जुड़ा।",
  "first unpaid day": "पहला बिना भुगतान का दिन",
  "in at {{time}}": "{{time}} पर अंदर",
  "left out": "छोड़े गए",
  "next number": "अगला नंबर",
  "no day rate yet": "दिन का रेट अभी नहीं",
  "of {{in}} in": "{{in}} इंच में से",
  "optional": "ज़रूरी नहीं",
  "optional · can be set later": "ज़रूरी नहीं · बाद में भर सकते हैं",
  "optional, can be set later": "ज़रूरी नहीं, बाद में भर सकते हैं",
  "per girah": "प्रति गिरह",
  "per inch": "प्रति इंच",
  "ready to add": "जोड़ने को तैयार",
  "to check": "जाँच में",
  "today": "आज",
  "wait for your OK.": "आपकी मंज़ूरी का इंतज़ार कर रही हैं।",
  "weaver": "बुनकर",
  "yesterday": "कल",
  "{{a}} added, {{r}} to check": "{{a}} जुड़े, {{r}} जाँच में",
  "{{done}} of {{n}} done": "{{n}} में से {{done}} हो गए",
  "{{done}} of {{n}} looms done": "{{n}} में से {{done}} लूम हो गए",
  "{{name}} is added. Take the photo again later.": "{{name}} जुड़ गए। फ़ोटो बाद में दोबारा लें।",
  "{{n}} days": "{{n}} दिन",
  "{{n}} days without a rate · since {{day}}": "{{n}} दिन बिना रेट · {{day}} से",
  "{{n}} entries are now paid": "{{n}} एंट्री अब भुगतान में जुड़ गईं",
  "{{n}} entries · the owner will check": "{{n}} एंट्री · मालिक देखेंगे",
  "{{n}} in now": "{{n}} अभी अंदर",
  "{{n}} late entries": "{{n}} देर की एंट्री",
  "{{n}} looms added": "{{n}} लूम जुड़ गए",
  "{{n}} of {{total}} marked out": "{{total}} में से {{n}} बाहर लगे",
  "{{n}} rows read": "{{n}} पंक्तियाँ पढ़ीं",
  "{{n}} saved on this phone and not sent yet.": "{{n}} इस फ़ोन पर सेव हैं, अभी भेजे नहीं गए।",
  "{{n}} skipped. They stay on the list for next time.": "{{n}} छोड़े गए। अगली बार के लिए सूची में रहेंगे।",
  "{{n}} waiting": "{{n}} बाकी",
  "{{n}} waiting for a rate.": "{{n}} रेट के इंतज़ार में।",
  "{{n}} waiting for a rate. The owner has been told. Work is saved.": "{{n}} रेट के इंतज़ार में। मालिक को बताया गया। काम सेव है।",
  "{{n}} without a code get the next code of their work (K_1, J_2…).": "{{n}} बिना कोड वालों को उनके काम का अगला कोड मिलेगा (K_1, J_2…)।",
  "{{who}}'s days are now paid": "{{who}} के दिन अब भुगतान में जुड़ गए",
  "Added ✓": "जुड़ गया ✓",
  "1–3 days": "1–3 दिन",
  "{{n}} in · {{out}} out": "{{n}} अंदर · {{out}} बाहर",
  "1 design has no rate.": "1 डिज़ाइन का रेट नहीं है।",
  "{{n}} designs have no rate.": "{{n}} डिज़ाइनों का रेट नहीं है।",
  "1 person has no day rate.": "1 व्यक्ति का दिन का रेट नहीं है।",
  "{{n}} people have no day rate.": "{{n}} लोगों का दिन का रेट नहीं है।",
  "1 entry is waiting to be paid.": "1 एंट्री भुगतान के इंतज़ार में है।",
  "{{n}} entries are waiting to be paid.": "{{n}} एंट्री भुगतान के इंतज़ार में हैं।",
  "Type a design number, e.g. DN-1497": "डिज़ाइन नंबर लिखें, जैसे DN-1497",
  "Add new design “{{n}}”": "नया डिज़ाइन “{{n}}” जोड़ें",
  "No designs yet. Type a number to add one.": "अभी कोई डिज़ाइन नहीं। जोड़ने के लिए नंबर लिखें।",
  "Code": "कोड",
  "given when you save": "सेव करने पर मिलेगा",
  "Remove photo": "फ़ोटो हटाएँ",
  "Last 7 days": "पिछले 7 दिन",
  "This week": "इस हफ़्ते",
  "Last week": "पिछले हफ़्ते",
  "Dates": "तारीख़ें",
  "to": "से",
  "1 entry still has no rate. It is left off the sheet until the rate is filled.": "1 एंट्री का रेट अभी नहीं है। रेट भरने तक यह पत्रक में नहीं आएगी।",
  "{{n}} entries still have no rate. They are left off the sheet until the rate is filled.": "{{n}} एंट्री का रेट अभी नहीं है। रेट भरने तक ये पत्रक में नहीं आएँगी।",
  "All of HKP": "पूरा HKP",
  "1 person has no day rate, so their hours are not paid yet.": "1 व्यक्ति का दिन का रेट नहीं है, इसलिए उनके घंटे अभी भुगतान में नहीं हैं।",
  "{{n}} people have no day rate, so their hours are not paid yet.": "{{n}} लोगों का दिन का रेट नहीं है, इसलिए उनके घंटे अभी भुगतान में नहीं हैं।",
  "1 loom saved.": "1 लूम सेव हुआ।",
  "A closed loom counts as updated and never goes red.": "बंद लूम अपडेट माना जाता है और कभी लाल नहीं होता।",
  "Alone": "अकेले",
  "Enter moves down, Tab moves across. Paste a column copied from Excel or Google Sheets. Click a loom number for its page.": "Enter नीचे जाता है, Tab आगे। Excel या Google Sheet से कॉलम कॉपी करके पेस्ट करें। लूम नंबर पर क्लिक करें तो उसका पेज खुलेगा।",
  "Left": "बाकी",
  "Loom not working today? Mark it closed": "आज लूम नहीं चला? बंद लिखें",
  "Loom {{n}} closed": "लूम {{n}} बंद",
  "Loom {{n}} reopened": "लूम {{n}} फिर चालू",
  "No saree yet": "अभी साड़ी नहीं",
  "Nothing here for this filter.": "इस छँटाई में कुछ नहीं।",
  "Open loom": "लूम खोलें",
  "Open loom page": "लूम का पेज खोलें",
  "Pick a loom on the left.": "बाईं ओर से लूम चुनें।",
  "Reopen": "फिर चालू करें",
  "Save 1 loom": "1 लूम सेव करें",
  "Save all · Ctrl+S": "सब सेव करें · Ctrl+S",
  "Save {{n}} looms": "{{n}} लूम सेव करें",
  "Some looms not saved": "कुछ लूम सेव नहीं हुए",
  "Start one to enter work": "काम लिखने के लिए साड़ी शुरू करें",
  "Status": "स्थिति",
  "Tap a name to change who is on the loom today, or to mark it closed. Tap the loom number for its page.": "आज लूम पर कौन है बदलने या लूम बंद लिखने के लिए नाम दबाएँ। लूम का पेज लूम नंबर दबाकर खुलेगा।",
  "Typing": "लिख रहे हैं",
  "Use for today": "आज के लिए रखें",
  "Who is on it today": "आज इस पर कौन है",
  "counts as updated": "अपडेट माना गया",
  "last entry yesterday": "आख़िरी एंट्री कल",
  "last entry {{n}} days ago": "आख़िरी एंट्री {{n}} दिन पहले",
  "{{n}} closed": "{{n}} बंद",
  "{{ok}} looms saved.": "{{ok}} लूम सेव हुए।",
  "1 day": "1 दिन",
  "1 day without a rate · since {{day}}": "1 दिन बिना रेट · {{day}} से",
  "1 not counted": "1 गिना नहीं",
  "{{n}} not counted": "{{n}} गिने नहीं",
  "Action": "काम",
  "Add a supervisor to hand them cash for paying people.": "लोगों को भुगतान के लिए नकद देने को सुपरवाइज़र जोड़ें।",
  "Advance cut": "एडवांस कटौती",
  "Close": "बंद करें",
  "Could not work out the week. Try again in a moment.": "हफ़्ते का हिसाब नहीं बना। थोड़ी देर में फिर कोशिश करें।",
  "In your hand": "आपके पास",
  "In {{time}} · {{work}}": "{{time}} से अंदर · {{work}}",
  "Last pay sheet": "पिछला भुगतान पत्रक",
  "Mark several in at once": "एक साथ कई लोगों को अंदर लगाएँ",
  "NEW": "नया",
  "Net due": "देना बाकी",
  "No day rate": "दिन का रेट नहीं",
  "Nobody is marked in for {{day}} yet. Tap + New person, or Mark several in for people already in Workers.": "{{day}} अभी कोई अंदर नहीं लगा। + नया व्यक्ति दबाएँ, या पहले से जुड़े लोगों को एक साथ अंदर लगाएँ।",
  "Nobody to pay for these days yet.": "इन दिनों का अभी किसी का भुगतान नहीं।",
  "Not in yet": "अभी नहीं आए",
  "Not in yet · last came {{day}}": "अभी नहीं आए · आख़िरी बार {{day}}",
  "Open": "खोलें",
  "Out at {{time}}": "{{time}} पर बाहर",
  "Out {{time}}": "{{time}} बाहर",
  "Pay sheet": "भुगतान पत्रक",
  "Pick who gets the advance.": "चुनें कि एडवांस किसे देना है।",
  "Time + job": "समय + ठेका",
  "Total · {{n}} people": "कुल · {{n}} लोग",
  "Week {{range}}": "हफ़्ता {{range}}",
  "Why are they going out?": "बाहर क्यों जा रहे हैं?",
  "With {{name}} (supervisor)": "{{name}} (सुपरवाइज़र) के पास",
  "advances": "एडवांस",
  "last worked {{day}}": "आख़िरी काम {{day}}",
  "not in": "नहीं आए",
  "not yet": "अभी नहीं",
  "rate": "रेट",
  "wages due": "मज़दूरी बाकी",
  "{{name}} added ({{code}})": "{{name}} जुड़ गए ({{code}})",
  "{{name}} added ({{code}}) and marked in at {{time}}": "{{name}} जुड़ गए ({{code}}) और {{time}} पर अंदर लगे",
  "{{n}} came": "{{n}} आए",
  "{{n}} not yet": "{{n}} अभी नहीं",
  "{{paid}} of {{n}} paid": "{{n}} में से {{paid}} को भुगतान",
  "Not in today": "आज नहीं आए",
  "In since {{time}}": "{{time}} से अंदर",
  "Name or code, e.g. J_12": "नाम या कोड, जैसे J_12",
  "Not in yet today": "आज अभी नहीं आए",
  "Type a name or code. If they aren't in Workers yet, add them here.": "नाम या कोड लिखें। अगर वे कारीगरों में नहीं हैं, तो यहीं जोड़ें।",
  "No one called “{{name}}” in Workers.": "कारीगरों में “{{name}}” नाम का कोई नहीं।",
  "Looking in Workers…": "कारीगरों में खोज रहे हैं…",
  "Add “{{name}}” as a new person": "“{{name}}” को नए व्यक्ति के रूप में जोड़ें",
  "New person, not in Workers yet": "नया व्यक्ति, जो अभी कारीगरों में नहीं है",
  "Find or add someone": "ढूँढें या जोड़ें",
  "Who came?": "कौन आया?",
  "Find them first. Add only if they aren't there.": "पहले ढूँढें। न मिलें तभी जोड़ें।",
  "Back to search": "वापस खोज पर",
  "Weaver: code or name, e.g. K_56": "बुनकर: कोड या नाम, जैसे K_56",
  "Helper: code or name, e.g. J_12": "हेल्पर: कोड या नाम, जैसे J_12",
  "as a new weaver": "नए बुनकर के रूप में",
  "as a new helper": "नए हेल्पर के रूप में",
  "1 design": "1 डिज़ाइन",
  "1 late entry": "1 देर की एंट्री",
  "1 login": "1 लॉगिन",
  "1 person": "1 व्यक्ति",
  "Add 1 loom": "1 लूम जोड़ें",
  "Add {{n}} looms": "{{n}} लूम जोड़ें",
  "All rated": "सबका रेट है",
  "All {{n}}": "सभी {{n}}",
  "Cash with supervisors": "सुपरवाइज़र के पास नकद",
  "Check the range, e.g. 1-12": "रेंज जाँचें, जैसे 1-12",
  "Codes": "कोड",
  "Codes, KYC": "कोड, KYC",
  "DAILY WORK": "DAILY WORK",
  "Days to pay": "किन दिनों का भुगतान",
  "Designs, rates": "डिज़ाइन, रेट",
  "English + Hindi headings, dropdown for Work, an example row. Fill and upload.": "अंग्रेज़ी + हिंदी शीर्षक, काम की ड्रॉपडाउन, एक उदाहरण पंक्ति। भरें और अपलोड करें।",
  "Every saree": "हर साड़ी",
  "Excel": "Excel",
  "First day": "पहला दिन",
  "Import": "इम्पोर्ट",
  "Import rates": "रेट इम्पोर्ट",
  "K_, J_, D_…": "K_, J_, D_…",
  "Last day": "आख़िरी दिन",
  "Material prices": "सामान के दाम",
  "Money": "पैसा",
  "Nothing is added until you check the preview. People already in HKP are never changed.": "पूर्वावलोकन जाँचने तक कुछ नहीं जुड़ता। HKP में पहले से मौजूद लोग कभी नहीं बदले जाते।",
  "Nothing late": "कुछ देर का नहीं",
  "Old sheet": "पुरानी शीट",
  "One photo each": "हर व्यक्ति की एक फ़ोटो",
  "Per hour/day": "प्रति घंटा/दिन",
  "Per inch": "प्रति इंच",
  "Photos": "फ़ोटो",
  "Photos can't come from Excel; after the import HKP offers a quick photo round.": "Excel से फ़ोटो नहीं आतीं; इम्पोर्ट के बाद HKP फ़ोटो का एक जल्दी राउंड देता है।",
  "Pick…": "चुनें…",
  "Print / PDF": "प्रिंट / PDF",
  "Products, catalogues, certificates": "उत्पाद, कैटलॉग, प्रमाणपत्र",
  "Register, geotag": "रजिस्टर, जियोटैग",
  "S_1, S_3…": "S_1, S_3…",
  "Use our Excel template": "हमारा Excel टेम्पलेट",
  "Weekly, print": "हफ़्तेवार, प्रिंट",
  "net to pay": "देना है",
  "people": "लोग",
  "{{amount}} out": "{{amount}} बाहर",
  "{{n}} approved": "{{n}} मंज़ूर",
  "{{n}} designs": "{{n}} डिज़ाइन",
  "{{n}} in": "{{n}} इंच",
  "{{n}} logins": "{{n}} लॉगिन",
  "{{n}} people": "{{n}} लोग",
  "{{n}} people from earlier imports to check": "पिछले इम्पोर्ट के {{n}} लोग जाँचने हैं",
  "{{n}} days old": "{{n}} दिन पुराना",
  "Sarees and checks": "साड़ियाँ और जाँच",
  "tap to change": "बदलने के लिए दबाएँ",
  "Read “{{h}}” as": "“{{h}}” को ऐसे पढ़ें",
  "ready": "तैयार",
  "check": "जाँचें",
  "skipped": "छोड़े गए",
  "1 to check": "1 जाँचना है",
  "1 row left out: {{why}}": "1 पंक्ति छोड़ी: {{why}}",
  "{{n}} rows left out: {{why}}": "{{n}} पंक्तियाँ छोड़ीं: {{why}}",
  "They wait in To check; nothing is guessed.": "ये “जाँचें” में रहेंगे; कुछ अंदाज़े से नहीं होता।",
  "Codes K_1, J_2… are given automatically.": "K_1, J_2… कोड अपने आप मिलेंगे।",
  "Add 1 person": "1 व्यक्ति जोड़ें",
  "{{r}} wait in “To check”": "{{r}} “जाँचें” में रहेंगे",
  "“{{name}}” is in the list twice": "“{{name}}” सूची में दो बार है",
  "“{{name}}” is already in HKP as {{code}}": "“{{name}}” HKP में पहले से {{code}} है",
  "“{{name}}” is already in HKP": "“{{name}}” HKP में पहले से है",
  "work “{{word}}” not known: pick their work": "काम “{{word}}” पहचाना नहीं: उनका काम चुनें",
  "no work given: pick their work": "काम नहीं लिखा: उनका काम चुनें",
  "a row with no name": "बिना नाम की पंक्ति",
  "code {{code}} is already in HKP": "कोड {{code}} HKP में पहले से है",
  "code {{code}} is in the list twice": "कोड {{code}} सूची में दो बार है",
  "Already marked": "पहले से लगी है",
  "{{code}} was already marked by someone else": "{{code}} की हाज़िरी किसी और ने पहले ही लगा दी",
  "Already paid": "पहले ही भुगतान हो चुका",
  "{{code}} was already paid {{amount}} by {{who}}": "{{code}} को {{who}} ने पहले ही {{amount}} दे दिए",
  "{{name}} was just added as {{code}}. Same person?": "{{name}} अभी {{code}} के रूप में जोड़े गए। क्या यही हैं?",
  "Use {{code}}": "{{code}} चुनें",
  "Add another": "दूसरा जोड़ें",
  "Helper not needed": "हेल्पर की ज़रूरत नहीं",
  "Not needed": "ज़रूरत नहीं",
  "{{n}} looms added · {{s}} were already there": "{{n}} लूम जुड़े · {{s}} पहले से थे",
  "e.g. {{hint}}": "जैसे {{hint}}",
  "You are here": "आप यहाँ हैं",
  "Product": "प्रोडक्ट",
  "Draft": "ड्राफ़्ट",
  "Draft made": "ड्राफ़्ट बन गया",
  // One Import screen
  "A tab for each kind of record, an example row, a Read me in Hindi. Fill what you have.": "हर तरह की जानकारी का अलग टैब, एक उदाहरण लाइन, हिंदी में समझाने वाला पन्ना। जो है वही भरें।",
  "Add to my karkhana": "मेरे कारख़ाने में जोड़ें",
  "Added to your karkhana": "आपके कारख़ाने में जुड़ गया",
  "Advances owed": "बाकी एडवांस",
  "Advances owed: give or note them in Pay": "बाकी एडवांस: भुगतान में दें या लिखें",
  "Any Excel or CSV: people, looms, rates, sarees on looms, advances, old daily work. One tab or many, any order. Only what you have; add the rest any time.": "कोई भी Excel या CSV: लोग, लूम, रेट, लूम पर साड़ी, एडवांस, पुराना रोज़ का काम। एक टैब या कई, किसी भी क्रम में। जो है वही दें; बाकी कभी भी जोड़ें।",
  "Any sheet, any time": "कोई भी शीट, कभी भी",
  "Approve the rates in this file (they are paid from their start date)": "इस फ़ाइल के रेट मंज़ूर करें (शुरू की तारीख़ से भुगतान होगा)",
  "Checking a file needs a connection.": "फ़ाइल जाँचने के लिए इंटरनेट चाहिए।",
  "Copy HKP's prompt.": "HKP का प्रॉम्प्ट कॉपी करें।",
  "Copy prompt": "प्रॉम्प्ट कॉपी करें",
  "Couldn't read the file": "फ़ाइल नहीं पढ़ी जा सकी",
  "Download the Excel it makes and upload it here.": "वह जो Excel बनाए उसे डाउनलोड करके यहाँ डालें।",
  "Fill rates later": "रेट बाद में भरें",
  "Getting it…": "ला रहे हैं…",
  "Go to Daily work": "रोज़ के काम पर जाएँ",
  "Hide prompt": "प्रॉम्प्ट छिपाएँ",
  "History kept": "पुराना रिकॉर्ड",
  "Import another file": "दूसरी फ़ाइल डालें",
  "Kept as history. It is never paid again.": "पुराने रिकॉर्ड की तरह रखा जाएगा। इसका दोबारा भुगतान नहीं होगा।",
  "Look at old daily work": "पुराना रोज़ का काम देखें",
  "Looms: add a range like 1-12 on Home": "लूम: होम पर 1-12 जैसी रेंज डालें",
  "Messy or handwritten? Let your AI tidy it": "गड़बड़ या हाथ से लिखा है? अपने AI से ठीक करवाएँ",
  "Not added": "नहीं जुड़ा",
  "Not added: {{why}}": "नहीं जुड़ा: {{why}}",
  "Not in this file. Fine, add later": "इस फ़ाइल में नहीं है। कोई बात नहीं, बाद में जोड़ें",
  "Nothing already in HKP is changed. Give the same file again and nothing is added twice.": "HKP में पहले से जो है वह नहीं बदलेगा। वही फ़ाइल दोबारा दें तो कुछ दो बार नहीं जुड़ेगा।",
  "Nothing is added until you tap Add": "जोड़ें दबाने तक कुछ नहीं जुड़ेगा",
  "Nothing was added. Try again with signal.": "कुछ नहीं जुड़ा। नेटवर्क आने पर फिर कोशिश करें।",
  "Old daily work": "पुराना रोज़ का काम",
  "Open ChatGPT or Claude, attach your sheets or photos of registers, paste the prompt.": "ChatGPT या Claude खोलें, अपनी शीट या रजिस्टर की फ़ोटो लगाएँ, प्रॉम्प्ट पेस्ट करें।",
  "Paste it in ChatGPT or Claude with your files.": "इसे अपनी फ़ाइलों के साथ ChatGPT या Claude में पेस्ट करें।",
  "People from earlier imports to check": "पहले के इम्पोर्ट में जाँचने वाले लोग",
  "People: add them here later, or one by one as they come": "लोग: बाद में यहाँ जोड़ें, या जैसे आएँ एक-एक करके",
  "Prompt": "प्रॉम्प्ट",
  "Prompt copied": "प्रॉम्प्ट कॉपी हो गया",
  "Rates: work is saved and paid once rates are filled": "रेट: काम सेव रहता है, रेट भरते ही भुगतान होगा",
  "Reading the file…": "फ़ाइल पढ़ रहे हैं…",
  "Records already in a sheet or register? Import them": "रिकॉर्ड पहले से शीट या रजिस्टर में हैं? इम्पोर्ट करें",
  "Row {{row}} · {{who}}: {{why}}": "पंक्ति {{row}} · {{who}}: {{why}}",
  "Sarees on looms now": "अभी लूम पर साड़ी",
  "Sarees on looms: start them from Daily work": "लूम पर साड़ी: रोज़ के काम से शुरू करें",
  "See prompt": "प्रॉम्प्ट देखें",
  "See rate cards": "रेट कार्ड देखें",
  "Start from HKP's Excel": "HKP की Excel से शुरू करें",
  "Still to add, whenever you're ready": "अभी जोड़ना बाकी, जब चाहें",
  "Tabs not read: {{tabs}}": "ये टैब नहीं पढ़े: {{tabs}}",
  "Upload what you have": "जो है वह डालें",
  "from “{{tab}}”": "“{{tab}}” से",
  "{{design}}: {{why}}": "{{design}}: {{why}}",
  "{{n}} designs ready": "{{n}} डिज़ाइन तैयार",
  "{{n}} designs saved as drafts": "{{n}} डिज़ाइन ड्राफ़्ट में सेव",
  "{{n}} designs saved · {{a}} approved": "{{n}} डिज़ाइन सेव · {{a}} मंज़ूर",
  "{{n}} new": "{{n}} नए",
  "{{n}} new · {{a}} already in HKP": "{{n}} नए · {{a}} पहले से HKP में",
  "{{n}} people · ₹{{total}}": "{{n}} लोग · ₹{{total}}",
  "{{n}} recorded": "{{n}} दर्ज",
  "{{n}} rows have something to look at": "{{n}} पंक्तियों में कुछ देखना है",
  "{{n}} rows kept as history": "{{n}} पंक्तियाँ पुराने रिकॉर्ड में",
  "{{n}} rows left out (not people, or already in HKP)": "{{n}} पंक्तियाँ छोड़ीं (लोग नहीं, या पहले से HKP में)",
  "{{n}} rows · {{first}} – {{last}}": "{{n}} पंक्तियाँ · {{first}} – {{last}}",
  "{{n}} sarees started": "{{n}} साड़ियाँ शुरू",
  "{{n}} sarees to start": "{{n}} साड़ियाँ शुरू होंगी",
  "{{n}} to add": "{{n}} जुड़ेंगे",
  "{{n}} to check after adding (they wait in review)": "जोड़ने के बाद {{n}} जाँचने हैं (जाँच में रहेंगे)",
  "{{n}} to check in review": "{{n}} जाँच में",
  "no work given": "काम नहीं लिखा",
  "work not known": "काम नहीं पहचाना",
  "same name already in HKP": "यही नाम पहले से HKP में",
  "in the list twice": "सूची में दो बार",
  "code in the list twice": "कोड सूची में दो बार",
  "code already in HKP": "कोड पहले से HKP में",
  "no name": "नाम नहीं",
  "code has no letters": "कोड में अक्षर नहीं",
  "code letters not known": "कोड के अक्षर नहीं पहचाने",
  "{{n}} designs ready · {{u}} unchanged": "{{n}} डिज़ाइन तैयार · {{u}} में कोई बदलाव नहीं",
  "{{n}} sarees to start · {{a}} already on looms": "{{n}} साड़ियाँ शुरू होंगी · {{a}} पहले से लूम पर",
  "{{n}} designs already had these rates": "{{n}} डिज़ाइन में यही रेट पहले से थे",
  "{{n}} looms already had their saree": "{{n}} लूम पर साड़ी पहले से थी",
  "Already kept before": "पहले से रखा हुआ",
  "{{n}} rows were repeats and left out": "{{n}} पंक्तियाँ दोहराई थीं, छोड़ दीं",
  "{{n}} people · {{total}}": "{{n}} लोग · {{total}}",
  "{{n}} already had their advances in HKP (change them in Pay)": "{{n}} के एडवांस पहले से HKP में थे (भुगतान में बदलें)",
  "{{n}} rows checked · the owner keeps them in Old sheet": "{{n}} पंक्तियाँ जाँचीं · मालिक इन्हें पुरानी शीट में रखेंगे",
  // Savitri fixes: saree start date and number, loom rename/retire, people confirm, ladka sool, rate drafts
  "No approved rate": "मंज़ूर रेट नहीं",
  "Nothing was saved. Try again.": "कुछ सेव नहीं हुआ। फिर कोशिश करें।",
  "Other work: warping, dyeing…": "दूसरा काम: ताना, रंगाई…",
  "Loom {{old}} is now {{code}}": "लूम {{old}} अब {{code}} है",
  "Retire loom {{code}}? It disappears from the rounds and pickers; its sarees and history stay.": "लूम {{code}} हटाएँ? यह राउंड और सूचियों से हट जाएगा; इसकी साड़ियाँ और इतिहास बने रहेंगे।",
  "Retire loom": "लूम हटाएँ",
  "Why is it retired?": "क्यों हटाया जा रहा है?",
  "Loom {{code}} retired": "लूम {{code}} हटा दिया",
  "Retired: not shown in the rounds or pickers": "हटाया गया: राउंड और सूचियों में नहीं दिखेगा",
  "Rename loom": "लूम का नंबर बदलें",
  "New loom number": "लूम का नया नंबर",
  "Old entries keep showing, and searching the old number still finds this loom.": "पुरानी एंट्री दिखती रहेंगी, और पुराना नंबर खोजने पर भी यही लूम मिलेगा।",
  "Why (optional)": "क्यों (ज़रूरी नहीं)",
  "Save loom number": "लूम नंबर सेव करें",
  Changes: "बदलाव",
  "Paid on top of the rate only when the entry says ladka sool": "रेट के ऊपर, सिर्फ़ तब जब एंट्री में लड़का सूल लिखा हो",
  "Ladka sool extra": "लड़का सूल अतिरिक्त",
  "Ladka sool extra is in the same unit as the rate, paid only on entries marked ladka sool.": "लड़का सूल अतिरिक्त उसी इकाई में है जिसमें रेट है, सिर्फ़ लड़का सूल वाली एंट्री पर मिलता है।",
  "Rate versions": "रेट के संस्करण",
  "Each version pays work done between its dates. Drafts pay nothing until approved.": "हर संस्करण अपनी तारीख़ों के बीच हुए काम का भुगतान करता है। ड्राफ़्ट मंज़ूरी तक कुछ नहीं देता।",
  "{{from}} to {{to}}": "{{from}} से {{to}} तक",
  "from {{from}}": "{{from}} से",
  "would start {{from}}": "{{from}} से शुरू होगा",
  "in use today": "आज लागू",
  "The rates in force on that day are copied into a draft for you to change. A date before the first approved version adds older rates.": "उस दिन लागू रेट ड्राफ़्ट में कॉपी हो जाते हैं, आप बदल सकते हैं। पहले मंज़ूर संस्करण से पहले की तारीख़ पुराने रेट जोड़ती है।",
  draft: "ड्राफ़्ट",
  "Saree {{n}} is on it from {{day}} · tap to move its start": "साड़ी {{n}} इस पर {{day}} से है · शुरुआत बदलने के लिए दबाएँ",
  "Saree {{old}} is now {{n}}": "साड़ी {{old}} अब {{n}} है",
  "Change number": "नंबर बदलें",
  "A lower number is fine if it is free. New sarees still get numbers after the highest ever given; {{old}} is never given again.": "छोटा नंबर भी चलेगा अगर खाली हो। नई साड़ियों को अब तक के सबसे बड़े नंबर के बाद का नंबर मिलेगा; {{old}} दोबारा नहीं दिया जाएगा।",
  "Save number": "नंबर सेव करें",
  "Saree {{n}} from {{day}}": "साड़ी {{n}} {{day}} से",
  "Move its start to this day to enter work": "काम लिखने के लिए इसकी शुरुआत इस दिन पर करें",
  "Move start": "शुरुआत बदलें",
  "Saree {{n}} is on it from {{day}}": "साड़ी {{n}} इस पर {{day}} से है",
  "This part has no ladka sool rate on the rate card, so nothing extra is paid.": "रेट कार्ड में इस हिस्से का लड़का सूल रेट नहीं है, इसलिए कुछ अतिरिक्त नहीं मिलेगा।",
  "Ladka sool": "लड़का सूल",
  "ladka sool": "लड़का सूल",
  "Confirm the people": "लोग पक्का करें",
  "Confirm today's weaver and helper, or change them, before saving.": "सेव करने से पहले आज के बुनकर और हेल्पर पक्के करें, या बदलें।",
  "Confirm today's people": "आज के लोग पक्के करें",
  "The helper changed this week. Check before saving.": "इस हफ़्ते हेल्पर बदला है। सेव करने से पहले देख लें।",
  "Same as yesterday ✓": "कल जैसे ही ✓",
  "Yes, same ✓": "हाँ, यही ✓",
  "Different people? Tap Weaver today or Helper today above.": "दूसरे लोग? ऊपर आज का बुनकर या आज का हेल्पर दबाएँ।",
  "Woven with ladka sool": "लड़का सूल से बुना",
  "extra rate, if the rate card has one": "अतिरिक्त रेट, अगर रेट कार्ड में हो",
  "Saree {{n}} ({{design}}) is on this loom from {{day}}.": "साड़ी {{n}} ({{design}}) इस लूम पर {{day}} से है।",
  "Move its start to {{day}}?": "इसकी शुरुआत {{day}} कर दें?",
  "Move start to {{day}}": "शुरुआत {{day}} करें",
  "Start a different saree": "दूसरी साड़ी शुरू करें",
  "The loom was closed that day": "उस दिन लूम बंद था",
  "Its start can't move to this day": "इसकी शुरुआत इस दिन पर नहीं हो सकती",
  "Last time: weaver {{w}}, helper {{h}}. Same today?": "पिछली बार: बुनकर {{w}}, हेल्पर {{h}}। आज भी यही?",
  "Weaver {{w}}, helper {{h}}. Right for today?": "बुनकर {{w}}, हेल्पर {{h}}। आज के लिए सही?",
  "Nothing to approve": "मंज़ूर करने को कुछ नहीं",
  "None of these designs is on a loom now.": "इनमें से कोई डिज़ाइन अभी लूम पर नहीं है।",
  "Tick the designs to approve.": "मंज़ूर करने वाले डिज़ाइन चुनें।",
  "Approve {{n}} drafts for {{d}} designs? Approved rates pay work from their start dates.": "{{d}} डिज़ाइन के {{n}} ड्राफ़्ट मंज़ूर करें? मंज़ूर रेट अपनी शुरुआत की तारीख़ से काम का भुगतान करेंगे।",
  "Not approved": "मंज़ूर नहीं हुआ",
  Approved: "मंज़ूर",
  Discarded: "रद्द",
  "{{a}} approved · {{n}} not approved": "{{a}} मंज़ूर · {{n}} मंज़ूर नहीं",
  "Rate drafts": "रेट ड्राफ़्ट",
  "Drafts pay nothing until approved. A design can wait with several dated versions; they are approved together.": "ड्राफ़्ट मंज़ूरी तक कुछ नहीं देते। एक डिज़ाइन के कई तारीख़ वाले संस्करण साथ में मंज़ूर होते हैं।",
  "The studio owner approves them.": "स्टूडियो मालिक इन्हें मंज़ूर करते हैं।",
  "on a loom now": "अभी लूम पर",
  "Approve all drafts for these {{n}} designs": "इन {{n}} डिज़ाइन के सभी ड्राफ़्ट मंज़ूर करें",
  "Approve all drafts for these designs": "इन डिज़ाइन के सभी ड्राफ़्ट मंज़ूर करें",
  "Approve only designs on active looms": "सिर्फ़ चालू लूम वाले डिज़ाइन मंज़ूर करें",
  "to {{to}}": "{{to}} तक",
  "Not repriced": "दोबारा हिसाब नहीं हुआ",
  Someone: "कोई",
  "by the AI assistant": "AI सहायक द्वारा",
  "The next saree gets number {{n}}": "अगली साड़ी को नंबर {{n}} मिलेगा",
  "Saree numbers": "साड़ी नंबर",
  "Next saree number": "अगला साड़ी नंबर",
  "highest used {{n}}": "अब तक सबसे बड़ा {{n}}",
  "New sarees always get a number after the highest ever given. A number is never given twice, even after a saree is renumbered.": "नई साड़ी को हमेशा अब तक के सबसे बड़े नंबर के बाद का नंबर मिलता है। कोई नंबर दो बार नहीं दिया जाता, साड़ी का नंबर बदलने के बाद भी नहीं।",
  "Go on from (e.g. 18350)": "यहाँ से आगे (जैसे 18350)",
  "Set series start": "शुरुआती नंबर सेट करें",
  "Saree {{n}} is on the loom from {{day}}": "साड़ी {{n}} लूम पर {{day}} से है",
  "New start date": "शुरुआत की नई तारीख़",
  "Work is entered from {{day}}, so the start can be that day or earlier.": "काम {{day}} से लिखा है, इसलिए शुरुआत उसी दिन या पहले हो सकती है।",
  "No work entered yet. The start can't be in the future.": "अभी कोई काम नहीं लिखा। शुरुआत आगे की तारीख़ नहीं हो सकती।",
  "Saree {{n}} was on this loom until the day before {{day}}.": "साड़ी {{n}} इस लूम पर {{day}} से एक दिन पहले तक थी।",
  "Saree moves from {{from}} to {{to}}. Days before work was entered default to its first weaver and helper.": "साड़ी {{from}} से {{to}} पर जाएगी। काम लिखने से पहले के दिनों में इसके पहले बुनकर और हेल्पर माने जाएँगे।",
  "Save start date": "शुरुआत की तारीख़ सेव करें",
  "Loom number": "लूम नंबर",
  Retired: "हटाया गया",
  "Saree number series": "साड़ी नंबर क्रम",
  "Could not check the date": "तारीख़ जाँच नहीं हो सकी",
  "This date can't be used": "यह तारीख़ नहीं चलेगी",
  "The start can't be in the future": "शुरुआत आगे की तारीख़ नहीं हो सकती",
  "A saree can't start in the future": "साड़ी आगे की तारीख़ से शुरू नहीं हो सकती",
  "Confirm people": "लोग पक्के करें",
  "{{n}} looms wait for their weaver and helper to be confirmed.": "{{n}} लूम पर बुनकर और हेल्पर पक्के होने बाकी हैं।",
  "Same people as last time?": "पिछली बार वाले ही लोग?",
  "Ask the office to move saree {{n}}'s start": "साड़ी {{n}} की शुरुआत बदलने के लिए ऑफ़िस से कहें",
  "Any start date works: approved versions around it are adjusted, and work already entered in its dates is paid again at these rates.": "कोई भी शुरुआती तारीख़ चलेगी: आसपास के मंज़ूर संस्करण ठीक कर दिए जाते हैं, और इन तारीख़ों में लिखे काम का भुगतान इन रेट से दोबारा होता है।",
  "HKP fits them among the approved versions and says what changed.": "HKP इन्हें मंज़ूर संस्करणों के बीच लगाता है और बताता है क्या बदला।",
  "Pay worked out again": "भुगतान दोबारा निकाला गया",
  "{{n}} entries now use these rates.": "{{n}} एंट्री अब इन रेट से हैं।",
  "Another supervisor or admin marks your attendance": "आपकी हाज़िरी दूसरा सुपरवाइज़र या एडमिन लगाएगा",
  You: "आप",
  "marked by others": "दूसरे लगाएँगे",
  "Not marked": "नहीं लगी",

  // Supervisors: edit name/phone, map to a worker, fold in a login-less user
  "Edit {{name}}": "{{name}} बदलें",
  "Mobile number (they log in with this)": "मोबाइल नंबर (इसी से लॉगिन करते हैं)",
  "They'll be signed out on their phones and sign in again with the same PIN. Their worker's phone changes too.": "उनके फ़ोन से लॉग आउट हो जाएगा, वे उसी PIN से फिर लॉगिन करेंगे। उनके वर्कर का फ़ोन भी बदल जाएगा।",
  "e.g. took a new number": "जैसे नया नंबर लिया",
  "{{name}} is saved": "{{name}} सेव हो गया",
  "Fold in and use this phone": "मिलाएँ और यही फ़ोन रखें",
  "Could not load changes": "बदलाव लोड नहीं हो पाए",
  "No changes yet": "अभी कोई बदलाव नहीं",
  "This can't be done": "यह नहीं हो सकता",
  "{{user}} will be folded in: that separate login is retired and its phone is freed.": "{{user}} को मिला दिया जाएगा: वह अलग लॉगिन बंद होगा और उसका फ़ोन खाली हो जाएगा।",
  "{{worker}} will be {{name}}'s worker.": "{{worker}} अब {{name}} का वर्कर होगा।",
  "Portraits and products made under the old login stay as they are.": "पुराने लॉगिन से बने पोर्ट्रेट और प्रोडक्ट जैसे हैं वैसे रहेंगे।",
  "Map {{name}} to a worker": "{{name}} को वर्कर से जोड़ें",
  "Looks like the same person": "शायद यही व्यक्ति",
  "Same phone": "वही फ़ोन",
  "Same name": "वही नाम",
  "Karkhana user, no worker": "कारख़ाना यूज़र, वर्कर नहीं",
  "Has a login to fold in": "इसका लॉगिन मिलाया जाएगा",
  "Code, name or phone, e.g. K_273": "कोड, नाम या फ़ोन, जैसे K_273",
  "Find a worker": "वर्कर खोजें",
  "Type a code, name or phone to find their worker.": "उनका वर्कर खोजने के लिए कोड, नाम या फ़ोन लिखें।",
  "Could not search Workers. Try again.": "वर्कर्स में खोज नहीं हो पाई। फिर कोशिश करें।",
  "Login: {{name}}": "लॉगिन: {{name}}",
  "Fold in and map": "मिलाएँ और जोड़ें",
  "{{name}} is mapped": "{{name}} जुड़ गया",
  "Worker mapped": "वर्कर जोड़ा",
  "Worker unmapped": "वर्कर हटाया",
  "Login folded in": "लॉगिन मिलाया",
  Worker: "वर्कर",
  "Paid here as this worker": "इसी वर्कर के रूप में भुगतान",
  "Not mapped": "जुड़ा नहीं",
  Unmap: "अलग करें",
  "Unmap {{worker}} from {{name}}?": "{{worker}} को {{name}} से अलग करें?",
  "The worker, their attendance and pay stay. {{name}} keeps their login.": "वर्कर, उसकी हाज़िरी और भुगतान बने रहेंगे। {{name}} का लॉगिन भी रहेगा।",
  "Maybe {{worker}}": "शायद {{worker}}",
  "Map to worker": "वर्कर से जोड़ें",
  "Not found. Refresh and try again.": "नहीं मिला। पेज ताज़ा करके फिर कोशिश करें।",
  // Daily work: back-fill a past day, device copy of unsaved rows
  "1 loom restored from this phone": "1 लूम इस फ़ोन से वापस लाया गया",
  "{{n}} looms restored from this phone": "{{n}} लूम इस फ़ोन से वापस लाए गए",
  "Loom {{codes}} was already saved for this day; the saved entry is kept and this phone's copy dropped.":
    "लूम {{codes}} इस दिन के लिए पहले ही सेव हो चुका था; सेव की गई एंट्री रखी गई, इस फ़ोन की कॉपी हटा दी गई।",
  "{{n}} rows from this phone have no saree on this day any more and were dropped.":
    "इस फ़ोन की {{n}} पंक्तियों पर अब इस दिन कोई साड़ी नहीं है, इसलिए हटा दी गईं।",
  "{{n}} unsaved on {{day}}": "{{day}} के {{n}} सेव नहीं हुए",
  "Saree {{n}} · starts {{from}} → will start {{to}}": "साड़ी {{n}} · शुरुआत {{from}} → {{to}} हो जाएगी",
  "goes to Approvals": "मंज़ूरी में जाएगा",
  "starts {{from}} → {{to}}": "शुरुआत {{from}} → {{to}}",
  "Saree {{n}} already starts by {{to}} · {{work}}": "साड़ी {{n}} पहले से {{to}} तक शुरू है · {{work}}",
  "Saree {{n}} start {{from}} → {{to}} + {{work}}": "साड़ी {{n}} शुरुआत {{from}} → {{to}} + {{work}}",
  "Work a supervisor enters before a saree's start waits here too, with the start move.":
    "साड़ी की शुरुआत से पहले के दिन का सुपरवाइज़र का काम भी, शुरुआत बदलने के साथ, यहीं इंतज़ार करता है।",
  "Which part? Pick it before saving.": "कौन सा हिस्सा? सेव से पहले चुनें।",
  "Saving sends the work and the start move to Approvals.": "सेव करने पर काम और शुरुआत का बदलाव मंज़ूरी में जाएगा।",
  "1 loom needs its part picked before saving.": "1 लूम का हिस्सा सेव से पहले चुनना है।",
  "{{n}} looms need their part picked before saving.": "{{n}} लूम का हिस्सा सेव से पहले चुनना है।",
  "Choose the part": "हिस्सा चुनें",
  "Restored from this phone": "इस फ़ोन से वापस लाया गया",
  "This part is already saved for this day, or another saree is on the loom; this phone's copy dropped.":
    "यह हिस्सा इस दिन के लिए पहले ही सेव हो चुका है, या लूम पर दूसरी साड़ी है; इस फ़ोन की कॉपी हटा दी गई।",
  "Loom {{codes}} now has a different saree; this phone's copy dropped.": "लूम {{codes}} पर अब दूसरी साड़ी है; इस फ़ोन की कॉपी हटा दी गई।",

  // Saree history: change, move, remove and restore entries (owner/manager)
  "Remove this entry? Say why:": "यह एंट्री हटाएँ? कारण बताएँ:",
  "Sent to Approvals; it counts once the owner approves.": "मंज़ूरी में भेज दिया; मालिक की मंज़ूरी के बाद गिना जाएगा।",
  "Entry changed; pay worked out again.": "एंट्री बदल गई; भुगतान फिर से निकाला गया।",
  "Remove 1 entry": "1 एंट्री हटाएँ",
  "Remove {{n}} entries": "{{n}} एंट्री हटाएँ",
  "Restore the entry for {{day}}": "{{day}} की एंट्री वापस लाएँ",
  "What changes": "क्या बदलेगा",
  Restored: "वापस लाई गई",
  "Moved to another day": "दूसरे दिन पर ले जाई गई",
  "Moved to another saree": "दूसरी साड़ी पर ले जाई गई",
  Corrected: "सुधारी गई",
  Entered: "दर्ज की गई",
  "Already paid on {{sheet}}: {{amount}}": "{{sheet}} में पहले ही भुगतान हो चुका: {{amount}}",
  "Can't be changed": "बदला नहीं जा सकता",
  "This entry changed meanwhile. Check again.": "इस बीच यह एंट्री बदल गई। फिर से जाँचें।",
  "This entry is already paid. Only the owner can take it back on the next pay sheet.":
    "इस एंट्री का भुगतान हो चुका है। सिर्फ़ मालिक इसे अगले भुगतान पत्रक में वापस ले सकते हैं।",
  "The loom already has this part for this weaver on that day.": "उस दिन लूम पर इस बुनकर का यह हिस्सा पहले से है।",
  "No approved rate on that day, so it would be paid nothing. Approve a rate first.":
    "उस दिन कोई मंज़ूर रेट नहीं है, तो भुगतान शून्य होगा। पहले रेट मंज़ूर करें।",
  "The loom is closed on that day.": "उस दिन लूम बंद है।",
  "That saree is not on a loom on that day.": "उस दिन वह साड़ी किसी लूम पर नहीं थी।",
  "That day is outside the saree's start and finish.": "वह दिन साड़ी की शुरुआत और पूरी होने के बीच नहीं है।",
  "This entry is no longer there. Reload the page.": "यह एंट्री अब नहीं है। पेज फिर से खोलें।",
  "Only the owner or a manager can change this entry.": "यह एंट्री सिर्फ़ मालिक या मैनेजर बदल सकते हैं।",
  "Adjust on next pay sheet": "अगले भुगतान पत्रक में घटाएँ",
  "What was paid comes off the next pay sheet as a marked correction line.":
    "जो भुगतान हुआ था, वह अगले भुगतान पत्रक में सुधार की अलग पंक्ति में घटेगा।",
  "This entry is already paid. Only the owner can change it.": "इस एंट्री का भुगतान हो चुका है। सिर्फ़ मालिक इसे बदल सकते हैं।",
  "Move to another saree": "दूसरी साड़ी पर ले जाएँ",
  Why: "क्यों",
  "This entry is already paid. A change takes it off its pay sheet line.": "इस एंट्री का भुगतान हो चुका है। बदलने पर यह भुगतान पत्रक की पंक्ति से हटेगी।",
  "Pick the weaver": "बुनकर चुनें",
  "Inches must be more than 0": "इंच 0 से ज़्यादा होने चाहिए",
  "Pick a date": "तारीख़ चुनें",
  "The date can't be in the future": "तारीख़ आगे की नहीं हो सकती",
  "Remove entry": "एंट्री हटाएँ",
  "No connection. It may not have saved; try again.": "नेटवर्क नहीं है। शायद सेव नहीं हुआ; फिर से कोशिश करें।",
  "Earlier changes ({{n}})": "पहले के बदलाव ({{n}})",
  "Check again": "फिर से जाँचें",
  "Remove {{n}} entries? Say why:": "{{n}} एंट्री हटाएँ? कारण बताएँ:",
  "Bring back the entry for {{day}}? Say why:": "{{day}} की एंट्री वापस लाएँ? कारण बताएँ:",
  "Entered the wrong part on some days, or entries that shouldn't be there? Tick them to change the part or remove them together.":
    "कुछ दिनों में गलत हिस्सा दर्ज हुआ, या ऐसी एंट्री जो नहीं होनी चाहिए? उन्हें टिक करके साथ में हिस्सा बदलें या हटाएँ।",
  Restore: "वापस लाएँ",
  "Moved to {{day}} · saree {{n}}": "{{day}} · साड़ी {{n}} पर ले जाई गई",
  "Moved from {{day}} · saree {{n}}": "{{day}} · साड़ी {{n}} से लाई गई",
  "paid {{amount}} comes off the next pay sheet": "भुगतान हुए {{amount}} अगले भुगतान पत्रक में घटेंगे",
  "Already saved earlier; nothing was saved twice.": "यह पहले ही सेव हो चुका था; दोबारा कुछ सेव नहीं हुआ।",
  "That saree was not found.": "वह साड़ी नहीं मिली।",
  "Something in this change is not right. Check it and try again.": "इस बदलाव में कुछ ठीक नहीं है। जाँचकर फिर कोशिश करें।",
  "A pay sheet or another change is saving for this person or loom right now. Try again in a moment.":
    "इस व्यक्ति या लूम के लिए अभी भुगतान पत्रक या कोई और बदलाव सेव हो रहा है। थोड़ी देर में फिर कोशिश करें।",
  "This can't be saved as it is.": "यह ऐसे सेव नहीं हो सकता।",
  "Move asked for": "बदलाव माँगा गया",
  "Move approved": "बदलाव मंज़ूर",
  "Move rejected": "बदलाव नामंज़ूर",
  "Move waiting for approval": "बदलाव मंज़ूरी के इंतज़ार में",
  Correction: "सुधार",
  "Removed: {{what}}": "हटाया गया: {{what}}",
  "Moved, paid less: {{what}}": "बदला गया, कम भुगतान: {{what}}",
  "Corrected, paid less: {{what}}": "सुधारा गया, कम भुगतान: {{what}}",
  "Correction to recover": "सुधार की वसूली बाकी",
  "{{left}} left": "{{left}} बाकी",
  "Taken back on this sheet": "इस पत्रक में वसूला",
  "Left to recover on later sheets": "अगले पत्रकों में वसूली बाकी",
  "Nothing was saved. Check again and try once more.": "कुछ सेव नहीं हुआ। फिर से जाँचकर एक बार और कोशिश करें।",
  "Move from {{from}}": "{{from}} से बदलाव",

  // Usual round (supervisor's looms first), covering, managers paid as workers
  "Usual round": "रोज़ का राउंड",
  "Not set": "तय नहीं",
  "+{{n}} more": "+{{n}} और",
  "1 loom": "1 लूम",
  "{{n}} looms": "{{n}} लूम",
  "Edit {{name}}'s usual round": "{{name}} का रोज़ का राउंड बदलें",
  "{{name}}'s usual round": "{{name}} का रोज़ का राउंड",
  "{{name}}'s usual round is saved": "{{name}} का रोज़ का राउंड सेव हो गया",
  "Their looms show first. They can still enter any loom when covering for someone.":
    "इनके लूम सबसे ऊपर दिखेंगे। किसी और की जगह काम करते समय ये कोई भी लूम भर सकते हैं।",
  "Loom groups": "लूम समूह",
  "Find a loom": "लूम ढूँढें",
  "In a picked group": "चुने गए समूह में",
  "Save round": "राउंड सेव करें",
  "Save with no round": "बिना राउंड सेव करें",
  "My round ({{n}})": "मेरा राउंड ({{n}})",
  "All looms": "सभी लूम",
  "Which looms": "कौन से लूम",
  Covering: "किसी और की जगह",
  "Entered while covering a loom outside their usual round": "अपने रोज़ के राउंड से बाहर के लूम पर, किसी और की जगह दर्ज किया",
  Managers: "मैनेजर",
  "A manager who also works here can be paid as a worker. Someone else marks their attendance and enters their pay.":
    "जो मैनेजर यहाँ काम भी करते हैं, उन्हें वर्कर की तरह भुगतान हो सकता है। उनकी हाज़िरी और भुगतान कोई और दर्ज करेगा।",
  "Could not load managers": "मैनेजर लोड नहीं हुए",
  "No managers in this studio": "इस स्टूडियो में कोई मैनेजर नहीं",
  Phone: "फ़ोन",
  "Also works here": "यहाँ काम भी करते हैं",
  "1 pending outside your round": "आपके राउंड के बाहर 1 बाकी",
  "{{n}} pending outside your round": "आपके राउंड के बाहर {{n}} बाकी",
  "Show all": "सभी दिखाएँ",
  "a loom": "एक लूम",
  "{{what}} is retired and was taken off this round. Save to keep the change.": "{{what}} हटाया जा चुका है, इसलिए इस राउंड से निकाल दिया गया। बदलाव रखने के लिए सेव करें।",
  "{{what}} are retired and were taken off this round. Save to keep the change.": "{{what}} हटाए जा चुके हैं, इसलिए इस राउंड से निकाल दिए गए। बदलाव रखने के लिए सेव करें।",
  // Scanned saree label: stage card and its one next action.
  "Move to {{stage}}": "{{stage}} में भेजें",
  "Move {{piece}} to {{stage}} today?": "{{piece}} को आज {{stage}} में भेजें?",
  "Move": "भेजें",
  "Moving…": "भेज रहे हैं…",
  "Moved to {{stage}}.": "{{stage}} में भेज दिया।",
  "Saree {{n}}": "साड़ी {{n}}",
  "this piece": "यह पीस",
  "Weaving on loom {{loom}}": "लूम {{loom}} पर बुनाई",
  "No stage recorded yet": "अभी कोई चरण दर्ज नहीं",
  "Making stage": "बनने का चरण",
  "Stage": "चरण",
  "{{woven}} of {{full}} m woven": "{{full}} मी में से {{woven}} मी बुना",
  "Finished · left the karkhana": "तैयार · कारखाने से निकल गई",
  "Finished": "तैयार",
  "Add today’s work on Loom {{loom}}": "लूम {{loom}} पर आज का काम जोड़ें",
  "Edit stages": "चरण बदलें",
  "In your karkhana": "आपके कारखाने में",
  "Certificate published": "सर्टिफिकेट जारी",
  "Certificate not published yet": "सर्टिफिकेट अभी जारी नहीं",
  "View certificate": "सर्टिफिकेट देखें",
  "Journey": "सफ़र",
  "Weaving": "बुनाई",
  "Finishing": "फ़िनिशिंग",
  "Quality check": "क्वालिटी जाँच",
  "Production completed": "बनकर तैयार",
  "In restoration": "मरम्मत में",
  "Someone already moved this piece. Its current stage is shown now.": "किसी ने यह पीस पहले ही आगे भेज दिया। अभी का चरण दिख रहा है।",
  "Supervisors can only move a piece to its next stage. Ask the studio owner to skip or go back.": "सुपरवाइज़र पीस को सिर्फ़ अगले चरण में भेज सकते हैं। चरण छोड़ने या पीछे जाने के लिए स्टूडियो मालिक से कहें।",
  "This saree is still on the loom. Add today’s work instead; move it on after it is cut.": "यह साड़ी अभी लूम पर है। आज का काम जोड़ें; कटने के बाद आगे भेजें।",
  // Loom sheet v2: geotag chip, saree so far, people card, more parts, complete at full length
  Tagged: "टैग हो गया",
  "Not tagged": "टैग नहीं",
  "Loom location and photo": "लूम की लोकेशन और फ़ोटो",
  "Loom {{code}}: location and photo": "लूम {{code}}: लोकेशन और फ़ोटो",
  "Saree {{n}} so far": "साड़ी {{n}} अब तक",
  "Couldn't load the entries.": "एंट्री लोड नहीं हुईं।",
  "Loading entries…": "एंट्री लोड हो रही हैं…",
  "No entries yet": "अभी कोई एंट्री नहीं",
  "See all": "सब देखें",
  removed: "हटाई गई",
  "Part {{n}}": "हिस्सा {{n}}",
  "Remove part {{n}}": "हिस्सा {{n}} हटाएँ",
  "Part {{n}} being woven": "बुना जा रहा हिस्सा {{n}}",
  "Woven today, part {{n}}": "आज बुना, हिस्सा {{n}}",
  "Add another part": "एक और हिस्सा जोड़ें",
  "Part entered twice": "हिस्सा दो बार",
  "{{part}} is in two rows. Pick another part for one of them.": "{{part}} दो पंक्तियों में है। एक में दूसरा हिस्सा चुनें।",
  "{{who}} already has {{part}} on this day. Pick another part.": "{{who}} का {{part}} इस दिन पहले से दर्ज है। दूसरा हिस्सा चुनें।",
  "{{who}} already has this part on this day. Pick another part.": "{{who}} का यह हिस्सा इस दिन पहले से दर्ज है। दूसरा हिस्सा चुनें।",
  "Today on loom {{code}}": "आज लूम {{code}} पर",
  "Loom {{code}}": "लूम {{code}}",
  Day: "दिन",
  "Doesn't add to the saree's length": "साड़ी की लंबाई में नहीं जुड़ता",
  Karigar: "कारीगर",
  Jodiya: "जोड़िया",
  karigar: "कारीगर",
  jodiya: "जोड़िया",
  "Same people": "वही लोग",
  "Changed today": "आज बदले",
  "Different…": "अलग लोग…",
  "Change karigar": "कारीगर बदलें",
  "Change jodiya": "जोड़िया बदलें",
  "Keep from tomorrow?": "कल से भी रखें?",
  "Keep {{name}} as {{role}} from tomorrow too?": "{{name}} को कल से भी {{role}} रखें?",
  "Keep “{{mode}}” from tomorrow too?": "“{{mode}}” कल से भी रखें?",
  "Just today": "सिर्फ़ आज",
  "From now on": "अब से हमेशा",
  "People updated": "लोग बदल दिए",
  "Mark saree {{n}} complete": "साड़ी {{n}} पूरी करें",
  "Complete at {{full}} in · {{left}} in to go": "{{full}} इंच पर पूरी · {{left}} इंच बाकी",
  "Measured it full? Check length": "पूरी नाप ली? लंबाई जाँचें",
  "This saree": "यह साड़ी",
  "This loom": "यह लूम",
};
Object.assign(HI, HI_CASHBOOK_SUPERVISOR, HI_CASHBOOK_OWNER);
